import dn, { memo as Le, useState as ee, useMemo as k, useCallback as V, useEffect as J, useContext as Te, useReducer as un, useRef as nt, createContext as xs } from "react";
import { Button as ae, Icon as se, AnalysisIcon as Yn, Input as De, useNotifications as st, Grid as _, Box as Ce, Typography as xe, Radio as bt, Tooltip as pt, ContentBlock as $t, CheckboxCell as yt, Table as dr, Checkbox as ur, Block as pn, EmptyTableStub as ys, ButtonGroup as Ts, Select as mn, Spinner as Ie, Divider as fn, SEARCH_PRECISION_OPTIONS as Rt, Autocomplete as Ht, SearchPrecision as Is, Dialog as vs, DialogTitle as _s, DialogContent as Os, DialogActions as Ns, AISpinner as pr } from "@prometheus/components";
import { ModalContext as qe, useSimpleImport as bs, useExport as Rs, useSectionsNew as As, useGenerate as js, useFilterOptions as ws, useAvailableModels as Ps, getOverlayHistoryCount as Jt, pushOverlayHistoryState as Ds, useEntityNew as Ls, useRequest as Ms, DialogContext as Us, useAiEventsApi as ks, useIntervalWithCondition as $s } from "@prometheus/hooks";
import { api as U, getSortDirection as He, createFiltersPanelListConfig as Bs, createCrudMethodsListConfig as Ws, createHeadersFromMetadataAttributes as Vs, createSortingMethodListConfig as Fs, getConceptSetById as Xt, truncate as zs, convertLegacyConceptsToExtendedConcepts as mt, convertExtendedToLegacyConcepts as At, getNumberUUID as Gs, isEmpty as Ot, getReducerWithProduce as Cn, keyBy as Ys, getCodeLanguageByFileExtension as qn, isEqual as jt, getUUID as qs, createBreadcrumbsEntityConfig as Hs, isAiGeneratedMetadata as Zt, isAiStatusMetadata as Js, parseStatistics as Ks, formatFilterListNoFiql as Qs, isAiMetadataName as Xs } from "@prometheus/utils";
import { TypesOfContainer as j, NameConflictResolution as te, EntityIconNames as Ae, iconAnalyses as en, FileExtension as ke, ImportAtlasAsset as Ct, TypesOfSave as Ve, containerTypes as Zs, ConceptSetSectionTabs as we, TypesOfIncluded as ve, EntityTypes as Nt, mapStandardConceptTypes as eo } from "@prometheus/enums";
import { ICON_COLUMN as to, ID_COLUMN as no, NAME_COLUMN as mr, CREATED_COLUMN as ro, UPDATED_COLUMN as so, AUTHOR_COLUMN as oo, EntityTypeCell as $e, EntityImport as ao, FileContentType as ut, ImportMultipleSource as hn, NameWithAliasCell as io, ActionCell as co, FormElement as je, FormActionsContainer as fr, SubModuleDescriptionBlock as lo, TabWithCounter as Re, TabsNavigationNew as En, SpinnerWidgetContainer as Pe, CodeEditor as Tt, SecondaryContentWrapper as Be, Section as uo, ExportMultipleSource as Cr, PageList as hr, Statistics as po, useIsLibraryDataSteward as mo, useArchiveLibraryMember as fo, ErrorPage as Hn, Versions as Co, MetaAttributes as Jn, NestedInfoWrapper as ho, ConceptSetBaseInfo as Eo, PublishEntity as go, ConfirmationDialog as So } from "@prometheus/features";
import le from "@emotion/styled";
import { useNavigate as Bt, Link as xo, useLocation as Er, Routes as gr, Route as ye, useParams as Sr, useSearchParams as yo } from "react-router-dom";
import { Status as P, AiSuggestionStatus as Ze, EntityActions as To, ListActions as Io } from "@prometheus/types";
import { getSummary as vo, addCompareItem as _o, setBreadcrumbs as Oo } from "@prometheus/redux";
import { useDispatch as xr, useSelector as yr } from "react-redux";
var tn = { exports: {} }, ct = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kn;
function No() {
  if (Kn) return ct;
  Kn = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(s, a, o) {
    var i = null;
    if (o !== void 0 && (i = "" + o), a.key !== void 0 && (i = "" + a.key), "key" in a) {
      o = {};
      for (var l in a)
        l !== "key" && (o[l] = a[l]);
    } else o = a;
    return a = o.ref, {
      $$typeof: e,
      type: s,
      key: i,
      ref: a !== void 0 ? a : null,
      props: o
    };
  }
  return ct.Fragment = t, ct.jsx = n, ct.jsxs = n, ct;
}
var lt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qn;
function bo() {
  return Qn || (Qn = 1, process.env.NODE_ENV !== "production" && function() {
    function e(C) {
      if (C == null) return null;
      if (typeof C == "function")
        return C.$$typeof === ne ? null : C.displayName || C.name || null;
      if (typeof C == "string") return C;
      switch (C) {
        case D:
          return "Fragment";
        case b:
          return "Profiler";
        case L:
          return "StrictMode";
        case O:
          return "Suspense";
        case T:
          return "SuspenseList";
        case z:
          return "Activity";
      }
      if (typeof C == "object")
        switch (typeof C.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), C.$$typeof) {
          case y:
            return "Portal";
          case B:
            return (C.displayName || "Context") + ".Provider";
          case M:
            return (C._context.displayName || "Context") + ".Consumer";
          case g:
            var w = C.render;
            return C = C.displayName, C || (C = w.displayName || w.name || "", C = C !== "" ? "ForwardRef(" + C + ")" : "ForwardRef"), C;
          case N:
            return w = C.displayName || null, w !== null ? w : e(C.type) || "Memo";
          case K:
            w = C._payload, C = C._init;
            try {
              return e(C(w));
            } catch {
            }
        }
      return null;
    }
    function t(C) {
      return "" + C;
    }
    function n(C) {
      try {
        t(C);
        var w = !1;
      } catch {
        w = !0;
      }
      if (w) {
        w = console;
        var F = w.error, Q = typeof Symbol == "function" && Symbol.toStringTag && C[Symbol.toStringTag] || C.constructor.name || "Object";
        return F.call(
          w,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          Q
        ), t(C);
      }
    }
    function s(C) {
      if (C === D) return "<>";
      if (typeof C == "object" && C !== null && C.$$typeof === K)
        return "<...>";
      try {
        var w = e(C);
        return w ? "<" + w + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function a() {
      var C = G.A;
      return C === null ? null : C.getOwner();
    }
    function o() {
      return Error("react-stack-top-frame");
    }
    function i(C) {
      if (S.call(C, "key")) {
        var w = Object.getOwnPropertyDescriptor(C, "key").get;
        if (w && w.isReactWarning) return !1;
      }
      return C.key !== void 0;
    }
    function l(C, w) {
      function F() {
        R || (R = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          w
        ));
      }
      F.isReactWarning = !0, Object.defineProperty(C, "key", {
        get: F,
        configurable: !0
      });
    }
    function p() {
      var C = e(this.type);
      return de[C] || (de[C] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), C = this.props.ref, C !== void 0 ? C : null;
    }
    function c(C, w, F, Q, ce, oe, u, v) {
      return F = oe.ref, C = {
        $$typeof: h,
        type: C,
        key: w,
        props: oe,
        _owner: ce
      }, (F !== void 0 ? F : null) !== null ? Object.defineProperty(C, "ref", {
        enumerable: !1,
        get: p
      }) : Object.defineProperty(C, "ref", { enumerable: !1, value: null }), C._store = {}, Object.defineProperty(C._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(C, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(C, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: u
      }), Object.defineProperty(C, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: v
      }), Object.freeze && (Object.freeze(C.props), Object.freeze(C)), C;
    }
    function d(C, w, F, Q, ce, oe, u, v) {
      var X = w.children;
      if (X !== void 0)
        if (Q)
          if ($(X)) {
            for (Q = 0; Q < X.length; Q++)
              m(X[Q]);
            Object.freeze && Object.freeze(X);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else m(X);
      if (S.call(w, "key")) {
        X = e(C);
        var q = Object.keys(w).filter(function(fe) {
          return fe !== "key";
        });
        Q = 0 < q.length ? "{key: someKey, " + q.join(": ..., ") + ": ...}" : "{key: someKey}", ue[X + Q] || (q = 0 < q.length ? "{" + q.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          Q,
          X,
          q,
          X
        ), ue[X + Q] = !0);
      }
      if (X = null, F !== void 0 && (n(F), X = "" + F), i(w) && (n(w.key), X = "" + w.key), "key" in w) {
        F = {};
        for (var ie in w)
          ie !== "key" && (F[ie] = w[ie]);
      } else F = w;
      return X && l(
        F,
        typeof C == "function" ? C.displayName || C.name || "Unknown" : C
      ), c(
        C,
        X,
        oe,
        ce,
        a(),
        F,
        u,
        v
      );
    }
    function m(C) {
      typeof C == "object" && C !== null && C.$$typeof === h && C._store && (C._store.validated = 1);
    }
    var E = dn, h = Symbol.for("react.transitional.element"), y = Symbol.for("react.portal"), D = Symbol.for("react.fragment"), L = Symbol.for("react.strict_mode"), b = Symbol.for("react.profiler"), M = Symbol.for("react.consumer"), B = Symbol.for("react.context"), g = Symbol.for("react.forward_ref"), O = Symbol.for("react.suspense"), T = Symbol.for("react.suspense_list"), N = Symbol.for("react.memo"), K = Symbol.for("react.lazy"), z = Symbol.for("react.activity"), ne = Symbol.for("react.client.reference"), G = E.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, S = Object.prototype.hasOwnProperty, $ = Array.isArray, Y = console.createTask ? console.createTask : function() {
      return null;
    };
    E = {
      react_stack_bottom_frame: function(C) {
        return C();
      }
    };
    var R, de = {}, W = E.react_stack_bottom_frame.bind(
      E,
      o
    )(), he = Y(s(o)), ue = {};
    lt.Fragment = D, lt.jsx = function(C, w, F, Q, ce) {
      var oe = 1e4 > G.recentlyCreatedOwnerStacks++;
      return d(
        C,
        w,
        F,
        !1,
        Q,
        ce,
        oe ? Error("react-stack-top-frame") : W,
        oe ? Y(s(C)) : he
      );
    }, lt.jsxs = function(C, w, F, Q, ce) {
      var oe = 1e4 > G.recentlyCreatedOwnerStacks++;
      return d(
        C,
        w,
        F,
        !0,
        Q,
        ce,
        oe ? Error("react-stack-top-frame") : W,
        oe ? Y(s(C)) : he
      );
    };
  }()), lt;
}
process.env.NODE_ENV === "production" ? tn.exports = No() : tn.exports = bo();
var r = tn.exports;
const Xn = (e, t = te.CREATE_NEW_OBJECT) => `${e}?resolution=${encodeURIComponent(t)}`, Kt = {}, Ro = (e) => e.includes("/copy/") ? "copy" : e.includes("/import/") ? "import" : "default", Ao = (e) => {
  switch (e) {
    case te.COPY:
      return Array.from(/* @__PURE__ */ new Set([e, "COPY"]));
    case te.CREATE_NEW_VERSION:
      return Array.from(
        /* @__PURE__ */ new Set([
          "NEW_VERSION",
          e,
          "CREATE_NEW_VERSION",
          "create_new_version",
          "create-new-version"
        ])
      );
    case te.CREATE_NEW_OBJECT:
    default:
      return Array.from(
        /* @__PURE__ */ new Set([
          "NEW_OBJECT",
          e,
          "CREATE_NEW_OBJECT",
          "CREATE_NEW",
          "create_new",
          "create-new"
        ])
      );
  }
}, ht = (e, t, n = te.CREATE_NEW_OBJECT) => {
  const s = Ro(e), a = Kt[s], o = s !== "import";
  if (o && a === null)
    return U.post(e, t);
  if (o && typeof a == "string")
    return U.post(Xn(e, a), t).catch((p) => {
      var c;
      if (((c = p == null ? void 0 : p.response) == null ? void 0 : c.status) === 400)
        return delete Kt[s], ht(e, t, n);
      throw p;
    });
  const i = [
    ...Ao(n),
    void 0
  ], l = (p) => {
    const c = i[p], d = c ? Xn(e, c) : e;
    return U.post(d, t).then((m) => (Kt[s] = c ?? null, m)).catch((m) => {
      var E;
      if (((E = m == null ? void 0 : m.response) == null ? void 0 : E.status) === 400 && p < i.length - 1)
        return l(p + 1);
      throw m;
    });
  };
  return l(0);
}, Tr = (e, t) => {
  const n = encodeURIComponent(e), s = t ? `&entityId=${encodeURIComponent(t)}` : "";
  return `name=${n}${s}`;
}, Ir = (e) => {
  const { pageNumber: t, pageSize: n, sortBy: s, query: a } = e, o = He(s), i = `/conceptset/list?size=${n || ""}&page=${t || ""}&sort=${o}&${a || ""}`;
  return U.get(i);
}, vr = (e) => {
  const { pageNumber: t, pageSize: n, sortBy: s, query: a } = e, o = He(s), i = `/workspace/concept-sets/list?size=${n || ""}&page=${t || ""}&sort=${o}&${a || ""}`;
  return U.get(i);
}, _r = (e) => {
  const { pageNumber: t, pageSize: n, sortBy: s, query: a } = e, o = He(s), i = `/library/concept-sets/list?size=${n || ""}&page=${t || ""}&sort=${o}&${a || ""}`;
  return U.get(i);
}, Or = (e, t) => {
  const { pageNumber: n, pageSize: s, sortBy: a, query: o } = t, i = He(a), l = `/studies/${e}/concept-sets/list?size=${s || ""}&page=${n || ""}&sort=${i}&${o || ""}`;
  return U.get(l);
}, jo = (e) => {
  const t = `/conceptset/filter?${e}`;
  return U.get(t);
}, wo = () => U.get("/conceptset/sorts"), Po = () => U.get("/workspace/concept-sets/sorts"), Do = (e) => U.get(`/conceptset/${e}/usage/sorts`), Lo = (e) => {
  const t = `/workspace/concept-sets/filter?${e}`;
  return U.get(t);
}, Zn = (e, t) => {
  const n = `/conceptset/metadata-value/${e}/copy`;
  return U.post(n, t);
}, Mo = (e, t) => {
  const n = `/studies/${t}/concept-sets/filter?${e}`;
  return U.get(n);
}, Uo = (e) => {
  const t = `/library/concept-sets/filter?${e}`;
  return U.get(t);
}, Wt = (e) => U.get(`/conceptset/${e}`), Nr = (e, t) => {
  const { pageNumber: n, pageSize: s, sortBy: a, query: o } = t, i = He(a), l = `/conceptset/${e}/usage/list?size=${s || ""}&page=${n || 0}&sort=${i}&${o || ""}`;
  return U.get(l);
}, ko = (e, t) => {
  const n = `/conceptset/${t}/usage/filter?${e}`;
  return U.get(n);
}, br = (e) => U.delete(`/conceptset/${e}`), gn = (e, t) => U.patch(`/conceptset/${e}`, t), Vt = (e) => U.post("/workspace/concept-sets", e), Rr = (e, t, n = te.COPY) => ht(
  `/workspace/concept-sets/copy/${e}`,
  t ? { name: t } : {},
  n
), Sn = (e, t) => U.post(`/studies/${e}/concept-sets`, t), Ar = (e, t, n, s = te.COPY) => ht(
  `/studies/${e}/concept-sets/copy/${t}`,
  n ? { name: n } : {},
  s
), $o = (e, t) => t !== "new" ? gn(t, e) : Vt(e), Bo = (e, t, n) => t !== "new" ? gn(t, e) : Sn(n, e), jr = (e, t) => U.post(`/conceptset/${e}/included/total`, t), wr = (e, t) => U.post(`/conceptset/${e}/included-source-code/total`, t), Pr = (e, t, n, s) => {
  const { pageNumber: a, pageSize: o, sortBy: i, query: l } = t, p = He(i), c = `/conceptset/${n}/${e}/list?size=${o || ""}&page=${a || ""}&sort=${p}` + (l ? `&${l}` : "");
  return U.post(c, s);
}, Dr = (e, t, n, s) => {
  const { pageNumber: a, pageSize: o, sortBy: i, query: l } = t, p = He(i), c = `/conceptset/${n}/${e}/filter?size=${o || ""}&page=${a || ""}&sort=${p}` + (l ? `&${l}` : "");
  return U.post(c, s);
}, Wo = (e) => U.get(`/conceptset/${e}/versions?size=10000`), Lr = (e) => U.get(`/conceptset/version/${e}`), Vo = (e) => U.post("/library/concept-set/invites", e), wt = (e, t) => {
  let n = "";
  e && t && (n += `?size=1000000&page=0&${e}=${t}`);
  const s = `/conceptset/metadata-value/list${n}`;
  return U.get(s);
}, nn = (e) => U.post("/conceptset/metadata-value", e), rn = (e, t) => {
  const n = `/conceptset/metadata-value/${t}`;
  return U.put(n, e);
}, er = (e) => {
  const t = `/conceptset/metadata-value/${e}`;
  return U.delete(t);
}, Fo = (e, t, n, s) => U.post(`/atlas/${e}/assets/${t}/export?id=${n}&name=${s}`), zo = (e) => U.get(`/conceptset/${e}/summary`), Go = (e, t) => U.patch(`/conceptset/${e}`, t), Yo = (e = "", t) => {
  {
    const n = e.replace(/^&/, ""), s = `/admin/metadata-attribute/list${n ? `?${n}` : ""}`;
    return U.get(s);
  }
}, qo = (e, t, n = te.CREATE_NEW_OBJECT) => ht(
  `/workspace/concept-sets/import/${e}`,
  t,
  n
), Ho = (e, t, n, s = te.CREATE_NEW_OBJECT) => ht(
  `/studies/${e}/concept-sets/import/${t}`,
  n,
  s
), Jo = (e, t) => U.get(
  `/workspace/concept-sets/check-name?${Tr(e, t)}`
), Ko = (e, t, n) => U.get(
  `/studies/${e}/concept-sets/check-name?${Tr(
    t,
    n
  )}`
), Mr = (e, t, n, s) => {
  switch (e) {
    case j.STUDY:
      if (!n)
        throw new Error("Study parentId is required for name check.");
      return Ko(n, t, s);
    case j.WORKSPACE:
    default:
      return Jo(t, s);
  }
}, tr = (e) => U.get(`/conceptset/suggestion/${e}/status`), Qo = (e) => U.get(`/conceptset/${e}/derived-stats`), Xo = (e) => {
  const { title: t, onClick: n, dense: s } = e;
  return /* @__PURE__ */ r.jsx(
    ae,
    {
      size: s ? "small" : "medium",
      fullWidth: !1,
      variant: "outlined",
      sx: { borderColor: "borderColor.main" },
      onClick: n,
      name: "importButton",
      startIcon: /* @__PURE__ */ r.jsx(se, { iconName: "import" }),
      children: t
    }
  );
}, Pt = (e, t) => Ws(
  e,
  t,
  Ir,
  br,
  Or,
  vr,
  _r
), Dt = (e, t) => Bs(
  e,
  t,
  jo,
  Mo,
  Lo,
  Uo
), Zo = (e) => Fs(e, {
  getSorting: wo,
  getSortingWorkspace: Po
}), rt = (e, t) => {
  switch (e) {
    case j.WORKSPACE:
      return (n, s) => Vt(n);
    case j.STUDY:
      return (n, s) => Sn(t, n);
  }
}, xn = (e, t) => {
  switch (e) {
    case j.WORKSPACE:
      return (n, s, a = te.CREATE_NEW_OBJECT) => qo(n, s, a);
    case j.STUDY:
      return (n, s, a = te.CREATE_NEW_OBJECT) => Ho(t, n, s, a);
  }
}, ea = (e, t, n, s, a) => {
  const o = ["workspace", "study-manager"], i = ["cohorts", "concept-sets", "analyses"], l = (y) => {
    const D = String(y || "").trim(), b = D.split(/[?#]/)[0].replace(/^\/+|\/+$/g, "").split("/").filter(Boolean), M = b.map((O) => O.toLowerCase()), B = M.findIndex(
      (O) => i.includes(O)
    );
    if (B >= 0) {
      const O = M[B], T = b[B + 1] || "";
      return {
        entity: O,
        entityId: T
      };
    }
    return {
      entity: void 0,
      entityId: (o.includes(M[0]) && b[1] ? b[1] : b[0]) || D
    };
  }, { entity: p, entityId: c } = l(e), d = String(t || "").trim().toUpperCase().replace(/[\s-]+/g, "_"), m = String(n || "").trim().toUpperCase().replace(/[\s-]+/g, "_"), E = s === j.WORKSPACE ? "/workspace" : `/study-manager/${a}`, h = (() => {
    var y;
    return p || (m.includes("COHORT") ? "cohorts" : m.includes("CONCEPT_SET") ? "concept-sets" : m.includes("ANALYSIS") ? "analyses" : d.includes("COHORT") ? "cohorts" : d.includes("CONCEPT_SET") ? "concept-sets" : (d === "ANALYSIS" || d.endsWith("_ANALYSIS") || (y = en) != null && y[d] && d !== "COHORT", "analyses"));
  })();
  return `${E}/${h}/${c}`;
}, Ft = [
  to({
    id: "typeIcon",
    accessorFn: (e) => e.type || Ae.CONCEPT_SET,
    cell: $e
  }),
  no(),
  mr(),
  ro(),
  so(),
  oo()
], ta = ({
  metaAttributes: e = []
} = {}) => [
  ...Ft,
  ...Vs(e, !0)
], nr = (e) => String(e || "").trim().toUpperCase().replace(/[\s-]+/g, "_"), na = ({ row: e }) => {
  var s, a, o, i;
  const t = nr((s = e == null ? void 0 : e.original) == null ? void 0 : s.supertype), n = nr((a = e == null ? void 0 : e.original) == null ? void 0 : a.type);
  return t === "COHORT" ? /* @__PURE__ */ r.jsx($e, { value: Ae.COHORT }) : t === "CONCEPT_SET" ? /* @__PURE__ */ r.jsx($e, { value: Ae.CONCEPT_SET }) : t === "ANALYSIS" ? (o = en) != null && o[n] ? /* @__PURE__ */ r.jsx(Yn, { value: n }) : /* @__PURE__ */ r.jsx($e, { value: Ae.ANALYSIS }) : (i = en) != null && i[n] ? /* @__PURE__ */ r.jsx(Yn, { value: n }) : n === "COHORT" ? /* @__PURE__ */ r.jsx($e, { value: Ae.COHORT }) : n === "CONCEPT_SET" ? /* @__PURE__ */ r.jsx($e, { value: Ae.CONCEPT_SET }) : /* @__PURE__ */ r.jsx($e, { value: Ae.ANALYSIS });
}, ra = [
  {
    header: "",
    accessorFn: (e) => e.type || e.supertype,
    id: "type",
    cell: na,
    size: 40,
    enableResizing: !1,
    meta: {
      columnType: "action"
    }
  },
  mr()
], sa = [
  {
    Component: De,
    name: "name",
    label: "Name",
    type: "text"
  },
  {
    Component: De,
    name: "description",
    label: "Description",
    type: "text",
    multiline: !0,
    minRows: 2,
    maxRows: 10
  }
], oa = "atlas", aa = "Error! Name is already used by another object.", ia = "Unable to validate name uniqueness. Please try again.", ca = (e) => typeof e == "boolean" ? e : !e || typeof e != "object" ? !0 : typeof e.available == "boolean" ? e.available : typeof e.isAvailable == "boolean" ? e.isAvailable : typeof e.success == "boolean" ? e.success : typeof e.result == "boolean" ? e.result : typeof e.unique == "boolean" ? e.unique : typeof e.isUnique == "boolean" ? e.isUnique : typeof e.valid == "boolean" ? e.valid : typeof e.isValid == "boolean" ? e.isValid : typeof e.exists == "boolean" ? !e.exists : typeof e.duplicate == "boolean" ? !e.duplicate : typeof e.conflict == "boolean" ? !e.conflict : typeof e.used == "boolean" ? !e.used : !0, yn = Le(
  (e) => {
    const {
      onChange: t,
      onClose: n,
      createMethod: s,
      typeContainer: a,
      parentId: o,
      resolution: i = te.CREATE_NEW_OBJECT,
      onResolutionChange: l
    } = e, { enqueueSnackbar: p } = st(), [c, d] = ee(!1), [m, E] = ee(""), [h, y] = ee(""), D = k(() => sa, []), L = i === te.CREATE_NEW_OBJECT, b = V(() => {
      E("");
    }, []);
    J(() => {
      L || b();
    }, [L, b]);
    const M = V(
      async (N) => {
        var G, S, $, Y;
        d(!0);
        const K = ((G = N.name) == null ? void 0 : G.trim()) || "";
        if (L)
          try {
            const R = await Mr(
              a,
              K,
              o
            );
            if (!ca(R)) {
              E(
                (R == null ? void 0 : R.message) || aa
              ), d(!1);
              return;
            }
            b();
          } catch (R) {
            E(
              (($ = (S = R == null ? void 0 : R.response) == null ? void 0 : S.data) == null ? void 0 : $.message) || ia
            ), d(!1);
            return;
          }
        let z;
        try {
          z = JSON.parse(
            N.expression || ""
          );
        } catch {
          d(!1), p({
            message: "Imported concept set is invalid!",
            variant: "error"
          });
          return;
        }
        const ne = z.items || ((Y = z.expression) == null ? void 0 : Y.items);
        if (!ne) {
          d(!1), p({
            message: "Imported concept set is invalid!",
            variant: "error"
          });
          return;
        }
        try {
          const R = await s(
            oa,
            {
              name: K,
              description: N.description,
              expression: {
                items: ne
              }
            },
            i
          );
          t(R);
        } catch {
          d(!1), p({
            message: "Oops, something went wrong!!!",
            variant: "error"
          });
        }
      },
      [
        s,
        p,
        L,
        t,
        o,
        b,
        i,
        a
      ]
    ), B = !!l, g = l || ((N) => {
    });
    return /* @__PURE__ */ r.jsx(_, { container: !0, children: /* @__PURE__ */ r.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
      ao,
      {
        onSubmit: M,
        codeKey: "expression",
        nameKey: "name",
        editorTitle: "Concept Set Expression JSON",
        editorHeight: "53vh",
        fields: D,
        isLoading: c,
        fileExtension: ke.JSON,
        contentType: ut.APPLICATION_JSON,
        onCancel: n,
        submitButtonText: "Import",
        isSubmitDisabled: L && !!m && h.trim().length > 0,
        onFieldValueChange: (N, K) => {
          N === "name" && (y(K), b());
        },
        fieldErrors: {
          name: m
        },
        footerStart: B ? /* @__PURE__ */ r.jsxs(
          Ce,
          {
            display: "flex",
            alignItems: "center",
            columnGap: 1.5,
            flexWrap: "nowrap",
            sx: { maxWidth: "100%", overflowX: "auto", py: 0.5 },
            children: [
              /* @__PURE__ */ r.jsx(xe, { variant: "caption", sx: { whiteSpace: "nowrap" }, children: "Select conflict resolution method:" }),
              /* @__PURE__ */ r.jsxs(
                Ce,
                {
                  display: "flex",
                  alignItems: "center",
                  columnGap: 1.5,
                  sx: { whiteSpace: "nowrap" },
                  children: [
                    /* @__PURE__ */ r.jsxs(Ce, { display: "flex", alignItems: "center", columnGap: 0.75, children: [
                      /* @__PURE__ */ r.jsx(
                        bt,
                        {
                          checked: i === te.CREATE_NEW_VERSION,
                          onChange: () => g(
                            te.CREATE_NEW_VERSION
                          ),
                          name: "import-resolution-manual",
                          size: "small",
                          sx: { p: 0.25, "& .MuiSvgIcon-root": { fontSize: 16 } }
                        }
                      ),
                      /* @__PURE__ */ r.jsx(xe, { variant: "caption", children: "Overwrite existing concept-sets" }),
                      /* @__PURE__ */ r.jsx(pt, { text: "Fully identical concept set(s) will not be created, instead existing ones will be reused. Concept set(s) with the same name, but different content will create a new version of the existing ones and Cohort design will reference these newly created versions.", children: /* @__PURE__ */ r.jsx(
                        se,
                        {
                          iconName: "info",
                          sx: { fontSize: 12, color: "text.secondary" }
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ r.jsxs(Ce, { display: "flex", alignItems: "center", columnGap: 0.75, children: [
                      /* @__PURE__ */ r.jsx(
                        bt,
                        {
                          checked: i === te.CREATE_NEW_OBJECT,
                          onChange: () => g(
                            te.CREATE_NEW_OBJECT
                          ),
                          name: "import-resolution-manual",
                          size: "small",
                          sx: { p: 0.25, "& .MuiSvgIcon-root": { fontSize: 16 } }
                        }
                      ),
                      /* @__PURE__ */ r.jsx(xe, { variant: "caption", children: "Create new concept-sets" }),
                      /* @__PURE__ */ r.jsx(pt, { text: "New concept set(s) will be created, even if identical concept set(s) exist.", children: /* @__PURE__ */ r.jsx(
                        se,
                        {
                          iconName: "info",
                          sx: { fontSize: 12, color: "text.secondary" }
                        }
                      ) })
                    ] })
                  ]
                }
              )
            ]
          }
        ) : null
      }
    ) }) });
  }
);
le.div`
  padding: 8px 16px;
  .concept-set-list {
    > .content-block {
      border: none;
      box-shadow: none;
      > div {
        padding: 10px 0;
      }
    }
  }
`;
const la = le.div`
  padding: 0px 16px 16px;
`;
le.div`
  margin-top: 10px;
  .concept-set-table {
    visibility: hidden;
    max-height: 0;
    overflow-y: hidden;
    &.selected {
      visibility: visible;
      max-height: 600px;
      padding: 8px;
    }
  }

  :hover {
    .concept-set-table {
      visibility: visible;
      max-height: 600px;
      padding: 8px;
    }
  }
`;
le.div`
  padding: 10px 20px 0;
  border-bottom: 3px solid #d8e1ef;
  .item:not(.active-item) {
    background-color: #ffffff;
  }
`;
le.div`
  padding: 10px 0;
`;
le.div`
  padding: 10px;
  display: flex;
`;
const da = le.div`
  &:hover {
    text-decoration: underline;
  }
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  white-space: pre-wrap;
  .MuiCheckbox-root {
    padding: 2px;
    margin-right: 8px;
  }
  .MuiSvgIcon-root {
    font-size: 16px;
  }
`, ua = le.div`
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.grey[400];
}};
  padding: 12px;
  text-align: center;
`, pa = le($t)`
  font-size: 12px;
  margin-bottom: 8px;
  .collapsible-block__content-container {
    padding: 0;
    border-bottom-right-radius: 4px;
  }
  .collapsible-content-block__title {
    padding: 0 12px;
    line-height: 36px;
    & > .MuiSvgIcon-root {
      display: none;
    }
  }
`, ma = [
  {
    Header: "Id",
    accessor: "concept.CONCEPT_ID"
  },
  {
    Header: "Code",
    accessor: "concept.CONCEPT_CODE",
    maxWidth: 150,
    isCropped: !0
  },
  {
    Header: "Name",
    accessor: "concept.CONCEPT_NAME",
    maxWidth: 400,
    isCropped: !0
  },
  {
    Header: "Class",
    accessor: "concept.CONCEPT_CLASS_ID",
    maxWidth: 150,
    isCropped: !0
  },
  {
    Header: "Domain",
    accessor: "concept.DOMAIN_ID"
  },
  {
    Header: "Vocabulary",
    accessor: "concept.VOCABULARY_ID",
    maxWidth: 150,
    isCropped: !0
  },
  {
    Header: "Exclude",
    accessor: "excluded",
    align: "left",
    Cell: (e) => /* @__PURE__ */ r.jsx(yt, { ...e, align: "left", disabled: !0 }),
    disableSortBy: !0
  },
  {
    Header: "Descendants",
    accessor: "descendants",
    align: "left",
    Cell: (e) => /* @__PURE__ */ r.jsx(yt, { ...e, align: "left", disabled: !0 }),
    disableSortBy: !0
  },
  {
    Header: "Mapped",
    accessor: "mapped",
    align: "left",
    Cell: (e) => /* @__PURE__ */ r.jsx(yt, { ...e, align: "left", disabled: !0 }),
    disableSortBy: !0
  },
  {
    Header: "Hierarchy",
    accessor: "hierarchy",
    align: "left",
    Cell: (e) => /* @__PURE__ */ r.jsx(yt, { ...e, align: "left", disabled: !0 }),
    disableSortBy: !0
  }
], Ur = Le((e) => {
  const { conceptSets: t, currentConceptSet: n, onChange: s, viewMode: a } = e;
  return /* @__PURE__ */ r.jsx(r.Fragment, { children: t != null && t.length ? (t || []).filter(
    (o) => a ? (n == null ? void 0 : n.id) == o.id : o
  ).map((o) => {
    var i, l;
    return /* @__PURE__ */ r.jsx(
      pa,
      {
        collapsible: !a,
        defaultState: (n == null ? void 0 : n.id) == o.id,
        title: /* @__PURE__ */ r.jsxs(da, { children: [
          /* @__PURE__ */ r.jsx(
            ur,
            {
              disabled: a,
              checked: (n == null ? void 0 : n.id) == o.id,
              onClick: (p) => {
                s(o, !1);
              },
              sx: { mr: 2 }
            }
          ),
          o.name
        ] }),
        children: /* @__PURE__ */ r.jsx(
          la,
          {
            className: "concept-set-table" + ((n == null ? void 0 : n.id) == o.id ? " selected" : ""),
            children: (i = o == null ? void 0 : o.expression) != null && i.items && Object.values((l = o == null ? void 0 : o.expression) == null ? void 0 : l.items).length ? /* @__PURE__ */ r.jsx(
              dr,
              {
                columns: ma,
                data: Object.values(o.expression.items),
                onEdit: () => {
                }
              }
            ) : /* @__PURE__ */ r.jsx(ua, { children: "Empty concept set" })
          }
        )
      },
      o.id
    );
  }) : /* @__PURE__ */ r.jsx(pn, { children: /* @__PURE__ */ r.jsx(ys, { noDataText: "No concept sets found, please import or create a concept set" }) }) });
}), Lt = (e) => {
  if (typeof e == "number" && Number.isFinite(e))
    return String(e);
  if (typeof e != "string")
    return;
  const t = e.trim();
  return t.length > 0 ? t : void 0;
}, rr = (e, t = !1) => {
  var i;
  const n = e.data || e, s = Lt(n.uuid) || Lt(n.id), a = n.externalId ?? n.id, o = n.items || ((i = n.expression) == null ? void 0 : i.items) || {};
  return {
    id: t && a !== void 0 ? a : Gs(),
    name: n.name || "New Concept set",
    expression: {
      items: At(o)
    },
    versionId: n.versionId,
    currentVersionId: n.currentVersionId || n.versionId,
    version: n.version,
    versionOrdinal: n.versionOrdinal || n.version,
    currentVersionOrdinal: n.currentVersionOrdinal || n.versionOrdinal || n.version,
    ...s ? {
      isNewImport: !0,
      uuid: s,
      referenceId: s,
      externalId: a
    } : {}
  };
}, kr = Le((e) => {
  const {
    simpleButtonMode: t = !1,
    localImport: n = !1,
    embeddedReferenceOnly: s = !1,
    defaultValue: a,
    conceptSetId: o,
    conceptSets: i,
    onUpdate: l,
    onClear: p,
    typeContainer: c,
    parentId: d,
    subModules: m,
    dense: E = !0,
    circleMode: h,
    importMultiSelect: y = !1,
    ...D
  } = e, { openModal: L, closeModal: b } = Te(qe), [M, B] = ee(
    Xt(o, i || [])
  );
  J(() => {
    t || B(Xt(o, i || []));
  }, [o, i, t]);
  const g = k(() => xn(c, d), [c, d]), O = k(() => {
    const G = /* @__PURE__ */ new Set();
    return i.forEach((S) => {
      const $ = S;
      [
        $ == null ? void 0 : $.uuid,
        $ == null ? void 0 : $.id,
        $ == null ? void 0 : $.externalId
      ].map(Lt).forEach((Y) => {
        Y && G.add(Y);
      });
    }), G;
  }, [i]), T = s || c === j.LIBRARY, N = n && (!T || i.length > 0), K = k(
    () => (G) => {
      const S = (G == null ? void 0 : G.original) || {};
      return [
        S == null ? void 0 : S.id,
        S == null ? void 0 : S.uuid,
        S == null ? void 0 : S.externalId
      ].map(Lt).some(
        (Y) => !!(Y && O.has(Y))
      );
    },
    [O]
  ), z = () => {
    L(
      () => {
        var G;
        return /* @__PURE__ */ r.jsx(
          hn,
          {
            name: "concept-sets",
            currentContainer: c,
            parentId: d,
            onChange: async (S) => {
              const $ = (Array.isArray(S) ? S : []).filter(Boolean).map(
                (Y) => rr(Y, T)
              );
              if ($.length === 0) {
                b();
                return;
              }
              t || B($[0]), y ? $.forEach(
                (Y) => l(Y, !0)
              ) : l($[0], !0), b();
            },
            getEntity: Wt,
            createListMethods: Pt,
            cols: Ft,
            createListFiltersMethod: Dt,
            createMethodCreate: rt,
            subModules: m,
            analysisMode: !0,
            isSelect: y,
            hideConflictResolutionControls: !0,
            hidePendingCancelButton: !y,
            toggleSingleSelectionOnRowClick: !y,
            disableRowSelect: K,
            disableRowSelectOnSameContainerOnly: !0,
            atlasEntity: [Ct.CS],
            successMessage: "Concept set(s) successfully imported.",
            manualImport: !T,
            disableImportContainer: T,
            disableAltasImport: T,
            disableCopy: T,
            manualImportComponent: /* @__PURE__ */ r.jsx(
              yn,
              {
                typeContainer: c,
                createMethod: g,
                parentId: d,
                onClose: b,
                onChange: (S) => {
                  const $ = rr(
                    S,
                    T
                  );
                  t || B($), l($, !0), b();
                }
              }
            ),
            localImport: N,
            localImportComponent: /* @__PURE__ */ r.jsx(
              Ur,
              {
                onChange: (S, $) => {
                  t || B({
                    ...S,
                    expression: {
                      items: At(
                        S.expression.items || {}
                      )
                    }
                  }), l(
                    {
                      ...S,
                      expression: {
                        items: At(
                          S.expression.items || {}
                        )
                      }
                    },
                    $
                  ), b();
                },
                currentConceptSet: {
                  ...M,
                  expression: {
                    items: mt(
                      ((G = M == null ? void 0 : M.expression) == null ? void 0 : G.items) || []
                    )
                  }
                },
                conceptSets: i.map((S) => {
                  var $;
                  return {
                    ...S,
                    expression: {
                      items: mt(
                        (($ = S == null ? void 0 : S.expression) == null ? void 0 : $.items) || []
                      )
                    }
                  };
                })
              }
            )
          }
        );
      },
      "Import concept set",
      {
        onClose: b,
        closeOnClickOutside: !0
      }
    );
  }, ne = () => {
    B(null), p();
  };
  return /* @__PURE__ */ r.jsxs(Ts, { children: [
    /* @__PURE__ */ r.jsx(
      Xo,
      {
        title: M && !t ? zs(M.name, 35) : a,
        onClick: z
      }
    ),
    M && /* @__PURE__ */ r.jsx(
      ae,
      {
        size: "medium",
        variant: "outlined",
        className: "button-component-icon",
        onClick: ne,
        name: "clearCriteriaConceptSet",
        startIcon: /* @__PURE__ */ r.jsx(se, { iconName: "close", name: "delete" }),
        sx: {
          px: 0.5,
          "&.MuiButtonGroup-grouped": {
            minWidth: 32
          },
          ".start-icon": {
            margin: 0
          }
        }
      }
    )
  ] });
}), fa = {
  createCols: (e, t = {}, n = !1, s = []) => [
    {
      Header: "Name",
      accessor: "name",
      id: "name",
      isCropped: !0,
      width: "100%",
      minWidth: 250,
      maxWidth: 400,
      Cell: (a) => /* @__PURE__ */ r.jsx(
        io,
        {
          ...a,
          hasAlias: n,
          onChange: t.onUpdate,
          aliases: s,
          entityType: Ae.CONCEPT_SET
        }
      )
    },
    ...e ? [] : [
      {
        Header: "",
        accessor: "actions",
        isCropped: !0,
        maxWidth: 100,
        width: "7%",
        disableSortBy: !0,
        Cell: (a) => /* @__PURE__ */ r.jsx(
          co,
          {
            onRemove: () => t.onRemove(a.row.original.id)
          }
        )
      }
    ]
  ]
}, Ca = (e) => {
  var T, N, K;
  const {
    titleText: t,
    description: n,
    buttonText: s,
    typeContainer: a,
    parentId: o,
    onChange: i,
    initialData: l,
    isSelect: p,
    subModules: c,
    viewMode: d,
    withAlias: m = !1
  } = e, { createCols: E } = fa, { openModal: h, closeModal: y } = Te(qe), D = k(() => xn(a, o), [a, o]), { state: L, updateList: b, removeItem: M, updateItem: B } = bs(
    l,
    p,
    i,
    m
  ), g = E(
    d,
    {
      onRemove: M,
      onUpdate: B
    },
    m,
    Object.values(L).map((z) => z.alias || null)
  ), O = () => {
    h(
      () => /* @__PURE__ */ r.jsx(
        hn,
        {
          name: "concept-sets",
          currentContainer: a,
          parentId: o,
          defaultResolution: te.CREATE_NEW_OBJECT,
          hideConflictResolutionMethod: !0,
          hideConflictResolutionControls: !0,
          onChange: (z) => {
            z.forEach((ne) => {
              Wt(ne.id).then((G) => {
                b(G, y);
              });
            });
          },
          createListMethods: Pt,
          cols: Ft,
          createListFiltersMethod: Dt,
          createMethodCreate: rt,
          subModules: c,
          isSelect: p,
          atlasEntity: [Ct.CS],
          analysisMode: !0,
          successMessage: "Concept set(s) successfully imported.",
          manualImport: !0,
          manualImportComponent: /* @__PURE__ */ r.jsx(
            yn,
            {
              createMethod: D,
              typeContainer: a,
              parentId: o,
              onClose: y,
              onChange: (z) => {
                b([z], y);
              }
            }
          )
        }
      ),
      "Import concept set",
      {
        onClose: y,
        closeOnClickOutside: !0
      }
    );
  };
  return /* @__PURE__ */ r.jsx(
    $t,
    {
      elevated: !0,
      outlined: !0,
      title: t,
      actions: d ? void 0 : /* @__PURE__ */ r.jsx(_, { item: !0, children: /* @__PURE__ */ r.jsx(
        ae,
        {
          onClick: O,
          variant: "contained",
          color: "info",
          startIcon: /* @__PURE__ */ r.jsx(se, { iconName: "add", fontSize: "small" }),
          name: "importConceptSet",
          sx: { px: 3 },
          children: s
        }
      ) }),
      children: /* @__PURE__ */ r.jsxs(_, { container: !0, children: [
        /* @__PURE__ */ r.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
          _,
          {
            container: !0,
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "nowrap",
            mb: 1,
            children: /* @__PURE__ */ r.jsx(xe, { variant: "subtitle2", component: "div", children: n || "" })
          }
        ) }),
        ((T = Object.values(L)) == null ? void 0 : T.length) > 0 ? /* @__PURE__ */ r.jsx(_, { item: !0, xs: 12, className: "table-cohorts", children: /* @__PURE__ */ r.jsx(
          dr,
          {
            columns: g,
            data: Object.values(L),
            loadingMessage: "",
            totalElements: (N = Object.values(L)) == null ? void 0 : N.length,
            pageSize: (K = Object.values(L)) == null ? void 0 : K.length,
            enableSorting: p,
            tileView: !0
          }
        ) }) : /* @__PURE__ */ r.jsx(
          _,
          {
            item: !0,
            xs: 12,
            sx: {
              backgroundColor: "backgroundColor.main",
              textAlign: "center",
              p: 1
            },
            children: /* @__PURE__ */ r.jsx(xe, { variant: "subtitle2", color: "borderColor.main", children: "No concept sets" })
          }
        )
      ] })
    }
  );
}, ha = (e, t) => {
  var s, a;
  const n = (a = (s = e == null ? void 0 : e.response) == null ? void 0 : s.data) == null ? void 0 : a.message;
  return n || t;
}, Ea = (e) => typeof e == "boolean" ? e : !e || typeof e != "object" ? !0 : typeof e.available == "boolean" ? e.available : typeof e.isAvailable == "boolean" ? e.isAvailable : typeof e.success == "boolean" ? e.success : typeof e.result == "boolean" ? e.result : typeof e.unique == "boolean" ? e.unique : typeof e.isUnique == "boolean" ? e.isUnique : typeof e.valid == "boolean" ? e.valid : typeof e.isValid == "boolean" ? e.isValid : typeof e.exists == "boolean" ? !e.exists : typeof e.duplicate == "boolean" ? !e.duplicate : typeof e.conflict == "boolean" ? !e.conflict : typeof e.used == "boolean" ? !e.used : !0, ze = async (e, t, n, s) => {
  const a = t == null ? void 0 : t.trim();
  if (!a)
    return {
      isValid: !1,
      message: "Name is required."
    };
  try {
    const o = await Mr(
      e,
      a,
      n,
      s
    ), i = Ea(o);
    return {
      isValid: i,
      message: i ? void 0 : (o == null ? void 0 : o.message) || "Error! Name is already used by another object."
    };
  } catch (o) {
    return {
      isValid: !1,
      message: ha(
        o,
        "Unable to validate name uniqueness. Please try again."
      )
    };
  }
}, Tn = Le(
  (e) => {
    const { parentId: t, typeContainer: n, afterCreate: s, onCancel: a, createMethod: o } = e, [i, l] = ee(!1), [p, c] = ee(""), [d, m] = ee({
      name: "",
      description: "",
      studyId: t
    }), E = V(async () => {
      l(!0);
      const h = await ze(
        n,
        d.name,
        t
      );
      if (!h.isValid) {
        l(!1), c(h.message || "");
        return;
      }
      c(""), o(d).then((y) => {
        l(!1), s == null || s(y);
      });
    }, [t, d, o, n]);
    return /* @__PURE__ */ r.jsx(_, { container: !0, p: 2, children: /* @__PURE__ */ r.jsx(pn, { elevated: !0, outlined: !0, children: /* @__PURE__ */ r.jsxs(_, { container: !0, spacing: 2, p: 2, children: [
      /* @__PURE__ */ r.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsxs(je, { name: "name", textLabel: "Name", required: !0, children: [
        /* @__PURE__ */ r.jsx(
          De,
          {
            id: "name",
            name: "name",
            type: "text",
            size: "medium",
            value: d.name,
            placeholder: "Enter name",
            onChange: (h) => {
              c(""), m({ ...d, name: h.target.value });
            },
            fullWidth: !0
          }
        ),
        p && /* @__PURE__ */ r.jsx(xe, { color: "error.main", variant: "caption", children: p })
      ] }) }),
      /* @__PURE__ */ r.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(je, { name: "description", textLabel: "Description", children: /* @__PURE__ */ r.jsx(
        De,
        {
          id: "description",
          name: "description",
          type: "text",
          size: "medium",
          value: d.description,
          placeholder: "Enter description",
          onChange: (h) => m({ ...d, description: h.target.value }),
          fullWidth: !0,
          multiline: !0,
          minRows: 2,
          maxRows: 10
        }
      ) }) }),
      /* @__PURE__ */ r.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsxs(fr, { children: [
        /* @__PURE__ */ r.jsx(
          ae,
          {
            variant: "outlined",
            disabled: i,
            onClick: a,
            startIcon: /* @__PURE__ */ r.jsx(se, { iconName: "deactivate" }),
            name: "cancel",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ r.jsx(
          ae,
          {
            disabled: i || Ot(d.name),
            onClick: E,
            variant: "contained",
            color: "success",
            startIcon: /* @__PURE__ */ r.jsx(se, { iconName: "submit" }),
            name: "save",
            children: "Save"
          }
        )
      ] }) })
    ] }) }) });
  }
), ga = () => {
  const e = Bt(), { openModal: t, closeModal: n } = dn.useContext(qe), { enqueueSnackbar: s } = st(), a = (o) => {
    o.stopPropagation(), t(
      () => /* @__PURE__ */ r.jsx(
        Tn,
        {
          typeContainer: j.WORKSPACE,
          createMethod: Vt,
          onCancel: n,
          afterCreate: (i) => {
            s({
              message: "Concept set created successfully",
              variant: "success"
            }), e(`/workspace/concept-sets/${i.id}`), n();
          }
        }
      ),
      "Add concept set",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: n
      }
    );
  };
  return /* @__PURE__ */ r.jsx(
    lo,
    {
      title: "Concept sets",
      description: "Concept sets include a group of OMOP medical concepts. Construct a new concept set to describe a phenotype to be shared across different cohorts, analyses and even studies.",
      iconName: "conceptSets",
      onCardClick: () => e("/workspace/concept-sets"),
      children: /* @__PURE__ */ r.jsx(_, { item: !0, width: 90, textAlign: "right", children: /* @__PURE__ */ r.jsx(
        ae,
        {
          onClick: a,
          variant: "contained",
          color: "info",
          startIcon: /* @__PURE__ */ r.jsx(se, { iconName: "add" }),
          name: "save",
          children: "Create"
        }
      ) })
    }
  );
}, $r = (e, t, n, s) => (a, o, i = te.COPY) => {
  switch (e) {
    case j.STUDY:
      return Ar(t, a, o, i);
    case j.WORKSPACE:
      return Rr(a, o, i);
    case "ATLAS":
      return Fo(n, s, a, o);
  }
}, Sa = (e, t) => (n = 0, s = 1e6, a, o) => {
  switch (e) {
    case j.STUDY:
      return Or(t, {
        pageNumber: n,
        pageSize: s,
        sortBy: a,
        query: o
      });
    case j.WORKSPACE:
      return vr({
        pageNumber: n,
        pageSize: s,
        sortBy: a,
        query: o
      });
    case j.LIBRARY:
      return _r({
        pageNumber: n,
        pageSize: s,
        sortBy: a,
        query: o
      });
    default:
      return Ir({
        pageNumber: n,
        pageSize: s,
        sortBy: a,
        query: o
      });
  }
}, xa = (e, t) => {
  switch (e) {
    case j.WORKSPACE:
      return (n) => Vt(n);
    case j.STUDY:
      return (n) => Sn(t, n);
  }
}, ya = (e) => e.map((t) => ({
  value: t.id,
  name: t.name
}));
function sr(e) {
  const t = {};
  for (const n of Object.values(e))
    t[n.id] = n;
  return t;
}
function Ge(e) {
  var n;
  const t = {};
  for (const [s, a] of Object.entries(e)) {
    const o = (a == null ? void 0 : a.conceptId) ?? ((n = a == null ? void 0 : a.concept) == null ? void 0 : n.CONCEPT_ID);
    if (!Number.isFinite(Number(o)))
      continue;
    const { excluded: i, mapped: l, descendants: p, hierarchy: c } = a || {};
    t[s] = {
      conceptId: Number(o),
      excluded: !!i,
      mapped: !!l,
      descendants: !!p,
      hierarchy: !!c
    };
  }
  return t;
}
function Ta(e, t) {
  return e.filter((n) => t.includes(n.op));
}
function Ia(e) {
  return Object.fromEntries(
    Object.entries(e).map(([t, n]) => [t, { ...n, id: t }])
  );
}
const va = ["excluded", "mapped", "descendants", "hierarchy"];
function Br(e, t) {
  const n = {}, s = /* @__PURE__ */ new Set(), a = [];
  for (const o of e) {
    const i = o.path.match(/^\/items\/([^/]+)\/([^/]+)$/);
    if (o.op === "replace" && i && va.includes(i[2])) {
      const [l, p, c] = i;
      n[p] || (n[p] = {}), n[p][c] = o.value, s.add(p);
    } else {
      const l = o.path.replace(/^\/items\//, "/");
      a.push({
        ...o,
        path: l
      });
    }
  }
  for (const o of s) {
    const i = t[o];
    if (i) {
      const l = { ...i, ...n[o] };
      a.push({
        op: "replace",
        path: `/${o}`,
        value: l
      });
    }
  }
  return a;
}
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2022 Joachim Wester
 * MIT licensed
 */
var _a = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, a) {
      s.__proto__ = a;
    } || function(s, a) {
      for (var o in a) a.hasOwnProperty(o) && (s[o] = a[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function s() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
  };
}(), Oa = Object.prototype.hasOwnProperty;
function sn(e, t) {
  return Oa.call(e, t);
}
function on(e) {
  if (Array.isArray(e)) {
    for (var t = new Array(e.length), n = 0; n < t.length; n++)
      t[n] = "" + n;
    return t;
  }
  if (Object.keys)
    return Object.keys(e);
  var s = [];
  for (var a in e)
    sn(e, a) && s.push(a);
  return s;
}
function ge(e) {
  switch (typeof e) {
    case "object":
      return JSON.parse(JSON.stringify(e));
    case "undefined":
      return null;
    default:
      return e;
  }
}
function an(e) {
  for (var t = 0, n = e.length, s; t < n; ) {
    if (s = e.charCodeAt(t), s >= 48 && s <= 57) {
      t++;
      continue;
    }
    return !1;
  }
  return !0;
}
function We(e) {
  return e.indexOf("/") === -1 && e.indexOf("~") === -1 ? e : e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function Wr(e) {
  return e.replace(/~1/g, "/").replace(/~0/g, "~");
}
function cn(e) {
  if (e === void 0)
    return !0;
  if (e) {
    if (Array.isArray(e)) {
      for (var t = 0, n = e.length; t < n; t++)
        if (cn(e[t]))
          return !0;
    } else if (typeof e == "object") {
      for (var s = on(e), a = s.length, o = 0; o < a; o++)
        if (cn(e[s[o]]))
          return !0;
    }
  }
  return !1;
}
function or(e, t) {
  var n = [e];
  for (var s in t) {
    var a = typeof t[s] == "object" ? JSON.stringify(t[s], null, 2) : t[s];
    typeof a < "u" && n.push(s + ": " + a);
  }
  return n.join(`
`);
}
var Vr = (
  /** @class */
  function(e) {
    _a(t, e);
    function t(n, s, a, o, i) {
      var l = this.constructor, p = e.call(this, or(n, { name: s, index: a, operation: o, tree: i })) || this;
      return p.name = s, p.index = a, p.operation = o, p.tree = i, Object.setPrototypeOf(p, l.prototype), p.message = or(n, { name: s, index: a, operation: o, tree: i }), p;
    }
    return t;
  }(Error)
), re = Vr, Na = ge, et = {
  add: function(e, t, n) {
    return e[t] = this.value, { newDocument: n };
  },
  remove: function(e, t, n) {
    var s = e[t];
    return delete e[t], { newDocument: n, removed: s };
  },
  replace: function(e, t, n) {
    var s = e[t];
    return e[t] = this.value, { newDocument: n, removed: s };
  },
  move: function(e, t, n) {
    var s = Mt(n, this.path);
    s && (s = ge(s));
    var a = Ye(n, { op: "remove", path: this.from }).removed;
    return Ye(n, { op: "add", path: this.path, value: a }), { newDocument: n, removed: s };
  },
  copy: function(e, t, n) {
    var s = Mt(n, this.from);
    return Ye(n, { op: "add", path: this.path, value: ge(s) }), { newDocument: n };
  },
  test: function(e, t, n) {
    return { newDocument: n, test: ft(e[t], this.value) };
  },
  _get: function(e, t, n) {
    return this.value = e[t], { newDocument: n };
  }
}, ba = {
  add: function(e, t, n) {
    return an(t) ? e.splice(t, 0, this.value) : e[t] = this.value, { newDocument: n, index: t };
  },
  remove: function(e, t, n) {
    var s = e.splice(t, 1);
    return { newDocument: n, removed: s[0] };
  },
  replace: function(e, t, n) {
    var s = e[t];
    return e[t] = this.value, { newDocument: n, removed: s };
  },
  move: et.move,
  copy: et.copy,
  test: et.test,
  _get: et._get
};
function Mt(e, t) {
  if (t == "")
    return e;
  var n = { op: "_get", path: t };
  return Ye(e, n), n.value;
}
function Ye(e, t, n, s, a, o) {
  if (n === void 0 && (n = !1), s === void 0 && (s = !0), a === void 0 && (a = !0), o === void 0 && (o = 0), n && (typeof n == "function" ? n(t, 0, e, t.path) : Ut(t, 0)), t.path === "") {
    var i = { newDocument: e };
    if (t.op === "add")
      return i.newDocument = t.value, i;
    if (t.op === "replace")
      return i.newDocument = t.value, i.removed = e, i;
    if (t.op === "move" || t.op === "copy")
      return i.newDocument = Mt(e, t.from), t.op === "move" && (i.removed = e), i;
    if (t.op === "test") {
      if (i.test = ft(e, t.value), i.test === !1)
        throw new re("Test operation failed", "TEST_OPERATION_FAILED", o, t, e);
      return i.newDocument = e, i;
    } else {
      if (t.op === "remove")
        return i.removed = e, i.newDocument = null, i;
      if (t.op === "_get")
        return t.value = e, i;
      if (n)
        throw new re("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", o, t, e);
      return i;
    }
  } else {
    s || (e = ge(e));
    var l = t.path || "", p = l.split("/"), c = e, d = 1, m = p.length, E = void 0, h = void 0, y = void 0;
    for (typeof n == "function" ? y = n : y = Ut; ; ) {
      if (h = p[d], h && h.indexOf("~") != -1 && (h = Wr(h)), a && (h == "__proto__" || h == "prototype" && d > 0 && p[d - 1] == "constructor"))
        throw new TypeError("JSON-Patch: modifying `__proto__` or `constructor/prototype` prop is banned for security reasons, if this was on purpose, please set `banPrototypeModifications` flag false and pass it to this function. More info in fast-json-patch README");
      if (n && E === void 0 && (c[h] === void 0 ? E = p.slice(0, d).join("/") : d == m - 1 && (E = t.path), E !== void 0 && y(t, 0, e, E)), d++, Array.isArray(c)) {
        if (h === "-")
          h = c.length;
        else {
          if (n && !an(h))
            throw new re("Expected an unsigned base-10 integer value, making the new referenced value the array element with the zero-based index", "OPERATION_PATH_ILLEGAL_ARRAY_INDEX", o, t, e);
          an(h) && (h = ~~h);
        }
        if (d >= m) {
          if (n && t.op === "add" && h > c.length)
            throw new re("The specified index MUST NOT be greater than the number of elements in the array", "OPERATION_VALUE_OUT_OF_BOUNDS", o, t, e);
          var i = ba[t.op].call(t, c, h, e);
          if (i.test === !1)
            throw new re("Test operation failed", "TEST_OPERATION_FAILED", o, t, e);
          return i;
        }
      } else if (d >= m) {
        var i = et[t.op].call(t, c, h, e);
        if (i.test === !1)
          throw new re("Test operation failed", "TEST_OPERATION_FAILED", o, t, e);
        return i;
      }
      if (c = c[h], n && d < m && (!c || typeof c != "object"))
        throw new re("Cannot perform operation at the desired path", "OPERATION_PATH_UNRESOLVABLE", o, t, e);
    }
  }
}
function In(e, t, n, s, a) {
  if (s === void 0 && (s = !0), a === void 0 && (a = !0), n && !Array.isArray(t))
    throw new re("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
  s || (e = ge(e));
  for (var o = new Array(t.length), i = 0, l = t.length; i < l; i++)
    o[i] = Ye(e, t[i], n, !0, a, i), e = o[i].newDocument;
  return o.newDocument = e, o;
}
function Ra(e, t, n) {
  var s = Ye(e, t);
  if (s.test === !1)
    throw new re("Test operation failed", "TEST_OPERATION_FAILED", n, t, e);
  return s.newDocument;
}
function Ut(e, t, n, s) {
  if (typeof e != "object" || e === null || Array.isArray(e))
    throw new re("Operation is not an object", "OPERATION_NOT_AN_OBJECT", t, e, n);
  if (et[e.op]) {
    if (typeof e.path != "string")
      throw new re("Operation `path` property is not a string", "OPERATION_PATH_INVALID", t, e, n);
    if (e.path.indexOf("/") !== 0 && e.path.length > 0)
      throw new re('Operation `path` property must start with "/"', "OPERATION_PATH_INVALID", t, e, n);
    if ((e.op === "move" || e.op === "copy") && typeof e.from != "string")
      throw new re("Operation `from` property is not present (applicable in `move` and `copy` operations)", "OPERATION_FROM_REQUIRED", t, e, n);
    if ((e.op === "add" || e.op === "replace" || e.op === "test") && e.value === void 0)
      throw new re("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_REQUIRED", t, e, n);
    if ((e.op === "add" || e.op === "replace" || e.op === "test") && cn(e.value))
      throw new re("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED", t, e, n);
    if (n) {
      if (e.op == "add") {
        var a = e.path.split("/").length, o = s.split("/").length;
        if (a !== o + 1 && a !== o)
          throw new re("Cannot perform an `add` operation at the desired path", "OPERATION_PATH_CANNOT_ADD", t, e, n);
      } else if (e.op === "replace" || e.op === "remove" || e.op === "_get") {
        if (e.path !== s)
          throw new re("Cannot perform the operation at a path that does not exist", "OPERATION_PATH_UNRESOLVABLE", t, e, n);
      } else if (e.op === "move" || e.op === "copy") {
        var i = { op: "_get", path: e.from, value: void 0 }, l = Fr([i], n);
        if (l && l.name === "OPERATION_PATH_UNRESOLVABLE")
          throw new re("Cannot perform the operation from a path that does not exist", "OPERATION_FROM_UNRESOLVABLE", t, e, n);
      }
    }
  } else throw new re("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", t, e, n);
}
function Fr(e, t, n) {
  try {
    if (!Array.isArray(e))
      throw new re("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
    if (t)
      In(ge(t), ge(e), n || !0);
    else {
      n = n || Ut;
      for (var s = 0; s < e.length; s++)
        n(e[s], s, t, void 0);
    }
  } catch (a) {
    if (a instanceof re)
      return a;
    throw a;
  }
}
function ft(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    var n = Array.isArray(e), s = Array.isArray(t), a, o, i;
    if (n && s) {
      if (o = e.length, o != t.length)
        return !1;
      for (a = o; a-- !== 0; )
        if (!ft(e[a], t[a]))
          return !1;
      return !0;
    }
    if (n != s)
      return !1;
    var l = Object.keys(e);
    if (o = l.length, o !== Object.keys(t).length)
      return !1;
    for (a = o; a-- !== 0; )
      if (!t.hasOwnProperty(l[a]))
        return !1;
    for (a = o; a-- !== 0; )
      if (i = l[a], !ft(e[i], t[i]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
const Aa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  JsonPatchError: re,
  _areEquals: ft,
  applyOperation: Ye,
  applyPatch: In,
  applyReducer: Ra,
  deepClone: Na,
  getValueByPointer: Mt,
  validate: Fr,
  validator: Ut
}, Symbol.toStringTag, { value: "Module" }));
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2021 Joachim Wester
 * MIT license
 */
var vn = /* @__PURE__ */ new WeakMap(), ja = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      this.observers = /* @__PURE__ */ new Map(), this.obj = t;
    }
    return e;
  }()
), wa = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      this.callback = t, this.observer = n;
    }
    return e;
  }()
);
function Pa(e) {
  return vn.get(e);
}
function Da(e, t) {
  return e.observers.get(t);
}
function La(e, t) {
  e.observers.delete(t.callback);
}
function Ma(e, t) {
  t.unobserve();
}
function Ua(e, t) {
  var n = [], s, a = Pa(e);
  if (!a)
    a = new ja(e), vn.set(e, a);
  else {
    var o = Da(a, t);
    s = o && o.observer;
  }
  if (s)
    return s;
  if (s = {}, a.value = ge(e), t) {
    s.callback = t, s.next = null;
    var i = function() {
      ln(s);
    }, l = function() {
      clearTimeout(s.next), s.next = setTimeout(i);
    };
    typeof window < "u" && (window.addEventListener("mouseup", l), window.addEventListener("keyup", l), window.addEventListener("mousedown", l), window.addEventListener("keydown", l), window.addEventListener("change", l));
  }
  return s.patches = n, s.object = e, s.unobserve = function() {
    ln(s), clearTimeout(s.next), La(a, s), typeof window < "u" && (window.removeEventListener("mouseup", l), window.removeEventListener("keyup", l), window.removeEventListener("mousedown", l), window.removeEventListener("keydown", l), window.removeEventListener("change", l));
  }, a.observers.set(t, new wa(t, s)), s;
}
function ln(e, t) {
  t === void 0 && (t = !1);
  var n = vn.get(e.object);
  _n(n.value, e.object, e.patches, "", t), e.patches.length && In(n.value, e.patches);
  var s = e.patches;
  return s.length > 0 && (e.patches = [], e.callback && e.callback(s)), s;
}
function _n(e, t, n, s, a) {
  if (t !== e) {
    typeof t.toJSON == "function" && (t = t.toJSON());
    for (var o = on(t), i = on(e), l = !1, p = i.length - 1; p >= 0; p--) {
      var c = i[p], d = e[c];
      if (sn(t, c) && !(t[c] === void 0 && d !== void 0 && Array.isArray(t) === !1)) {
        var m = t[c];
        typeof d == "object" && d != null && typeof m == "object" && m != null && Array.isArray(d) === Array.isArray(m) ? _n(d, m, n, s + "/" + We(c), a) : d !== m && (a && n.push({ op: "test", path: s + "/" + We(c), value: ge(d) }), n.push({ op: "replace", path: s + "/" + We(c), value: ge(m) }));
      } else Array.isArray(e) === Array.isArray(t) ? (a && n.push({ op: "test", path: s + "/" + We(c), value: ge(d) }), n.push({ op: "remove", path: s + "/" + We(c) }), l = !0) : (a && n.push({ op: "test", path: s, value: e }), n.push({ op: "replace", path: s, value: t }));
    }
    if (!(!l && o.length == i.length))
      for (var p = 0; p < o.length; p++) {
        var c = o[p];
        !sn(e, c) && t[c] !== void 0 && n.push({ op: "add", path: s + "/" + We(c), value: ge(t[c]) });
      }
  }
}
function zt(e, t, n) {
  n === void 0 && (n = !1);
  var s = [];
  return _n(e, t, s, "", n), s;
}
const ka = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compare: zt,
  generate: ln,
  observe: Ua,
  unobserve: Ma
}, Symbol.toStringTag, { value: "Module" }));
Object.assign({}, Aa, ka, {
  JsonPatchError: Vr,
  deepClone: ge,
  escapePathComponent: We,
  unescapePathComponent: Wr
});
var Fe = /* @__PURE__ */ ((e) => (e.LOADED_LIST = "LOADED_LIST", e.FAILED_LOADED_LIST = "FAILED_LOADED_LIST", e.IN_PROGRESS_CREATION = "IN_PROGRESS_CREATION", e.CREATED_SUCCESS = "CREATED_SUCCESS", e.UPDATED_SUCCESS = "UPDATED_SUCCESS", e))(Fe || {});
const $a = {
  conceptSets: [],
  status: P.INITIAL,
  typeContainer: j.WORKSPACE,
  conceptSet: null,
  parentId: null,
  error: null
}, Ba = (e, t) => Cn(
  e,
  (n) => {
    switch (t.type) {
      case "INITIAL_PARAMS":
        n.typeContainer = t.payload.typeContainer, n.parentId = t.payload.parentId;
        break;
      case "GET_CONCEPT_SETS":
        n.conceptSets = [], n.status = P.IN_PROGRESS;
        break;
      case "GET_CONCEPT_SETS_DONE":
        n.conceptSets = t.payload, n.status = "LOADED_LIST";
        break;
      case "GET_CONCEPT_SETS_FAILED":
        n.status = "FAILED_LOADED_LIST";
        break;
      case "CREATE_CONCEPT_SET":
      case "UPDATE_CONCEPT_SET":
        n.status = "IN_PROGRESS_CREATION";
        break;
      case "CREATE_CONCEPT_SET_DONE":
        n.conceptSet = t.payload, n.status = "CREATED_SUCCESS";
        break;
      case "UPDATE_CONCEPT_SET_DONE":
        n.conceptSet = t.payload, n.status = "UPDATED_SUCCESS";
        break;
    }
  }
), Wa = (e, t) => {
  const [n, s] = un(Ba, $a), a = (c, d) => {
    s({
      type: "INITIAL_PARAMS",
      payload: {
        typeContainer: c,
        parentId: d
      }
    });
  }, o = V(async () => {
    s({
      type: "GET_CONCEPT_SETS"
      /* GET_CONCEPT_SETS */
    });
    const c = Sa(n.typeContainer, n.parentId);
    try {
      const d = await c();
      s({
        type: "GET_CONCEPT_SETS_DONE",
        payload: ya(d.content)
      });
    } catch (d) {
      console.log("error", d), s({
        type: "GET_CONCEPT_SETS_FAILED"
        /* GET_CONCEPT_SETS_FAILED */
      });
    }
  }, [n.typeContainer, n.parentId]), i = V(
    async (c, d) => {
      s({
        type: "CREATE_CONCEPT_SET"
        /* CREATE_CONCEPT_SET */
      });
      try {
        const E = await xa(n.typeContainer, n.parentId)({
          name: c.title,
          items: Ge(sr(d))
        });
        s({
          type: "CREATE_CONCEPT_SET_DONE",
          payload: E
        });
      } catch {
      }
    },
    [n]
  ), l = V(
    async (c, d) => {
      s({
        type: "UPDATE_CONCEPT_SET"
        /* UPDATE_CONCEPT_SET */
      });
      try {
        const m = await Wt(
          c.conceptSetId
        ), E = zt(
          Ge(m.items),
          Ge(sr(d))
        );
        m && await gn(c.conceptSetId, {
          ...m,
          delta: Ta(E, ["add", "replace"])
        }), s({
          type: "UPDATE_CONCEPT_SET_DONE",
          payload: m
        });
      } catch {
      }
    },
    [n]
  ), p = V(
    async (c, d, m = []) => {
      d === Ve.NEW && await i(c, m), d === Ve.EXIST && await l(c, m);
    },
    [n]
  );
  return J(() => {
    e && a(e, t);
  }, []), J(() => {
    o();
  }, [n.typeContainer, n.parentId]), {
    ...n,
    setParams: a,
    conceptSetCreation: p
  };
}, Va = (e) => {
  const { conceptSets: t, status: n, existConceptSetId: s, setState: a } = e;
  return /* @__PURE__ */ r.jsxs(
    _,
    {
      container: !0,
      item: !0,
      xs: 12,
      md: 4,
      spacing: 1,
      alignItems: "center",
      flexWrap: "nowrap",
      children: [
        /* @__PURE__ */ r.jsx(_, { item: !0, className: "title-saving", width: { xs: 90, md: "auto" }, children: "Concept set" }),
        /* @__PURE__ */ r.jsx(_, { item: !0, display: "flex", flexGrow: 1, children: /* @__PURE__ */ r.jsx(
          mn,
          {
            className: "exist-concept-set",
            disabled: n !== Fe.LOADED_LIST,
            name: "exist-concept-set",
            disablePortal: !0,
            fullWidth: !0,
            id: "exist-concept-set",
            options: t || [],
            value: s,
            placeholder: /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
              "Select concept set...",
              " ",
              n === P.IN_PROGRESS && /* @__PURE__ */ r.jsx(Ie, { size: 14 })
            ] }),
            onChange: (o) => {
              a((i) => ({
                ...i,
                conceptSetId: o
              }));
            }
          }
        ) })
      ]
    }
  );
}, Fa = (e) => {
  const { title: t, setState: n } = e;
  return /* @__PURE__ */ r.jsxs(_, { container: !0, item: !0, xs: 12, md: 4, spacing: 1, alignItems: "center", children: [
    /* @__PURE__ */ r.jsx(_, { item: !0, className: "title-saving", width: { xs: 90, md: "auto" }, children: "Concept set" }),
    /* @__PURE__ */ r.jsx(_, { item: !0, flexGrow: 1, children: /* @__PURE__ */ r.jsx(
      De,
      {
        id: "create-new-concept-set",
        name: "title",
        type: "text",
        fullWidth: !0,
        value: t || "",
        onChange: (s) => {
          n((a) => ({
            ...a,
            title: s.target.value
          }));
        }
      }
    ) })
  ] });
};
le(ae)`
  margin-left: 20px;
  height: 35px;
  font-weight: 700;
  background: #ffffff !important;
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}} !important;
  border: 1px solid ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
  color: #ffffff;
  border-radius: 4px;
  font-size: 14px;
  text-transform: initial;
`;
le(ae)`
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}} !important;
  border: 1px solid ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
  background: #ffffff !important;
  font-weight: 700;
  border-radius: 4px;
  font-size: 14px;
  height: 35px;
  text-transform: initial;
`;
le(De)`
  border: none !important;
  margin-top: 1px !important;
  margin-left: 30px !important;
  .MuiInputBase-root {
    height: 35px !important;
    line-height: 24px !important;
    padding: 5px 10px !important;
    font-size: 16px !important;
    width: 300px !important;
  }
`;
le.div`
  text-align: right;
`;
const za = le.div`
  /* border-top: 1px solid #e7e7e7; */
  border-bottom: 1px solid ${({ theme: e }) => e.palette.borderColor.main};
  /* box-shadow: -2px 4px 8px -6px #343434; */
  background: #ffffff;
  padding: 8px 16px;

  .title-saving {
    color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
    font-weight: 700;
    padding-top: 10px;
    display: inline-block;
    font-size: 14px;
  }
`;
le(mn)`
  border: none !important;
  margin-top: 1px !important;
  margin-left: 30px !important;
  width: 300px !important;
  height: 35px !important;
  font-size: 16px !important;
`;
const Ga = Le(
  (e) => {
    const {
      concepts: t,
      subModules: n,
      typeContainer: s,
      parentId: a,
      component: o,
      onSave: i,
      onCancel: l,
      disableActions: p
    } = e, { enqueueSnackbar: c } = st(), [d, m] = ee(null), [E, h] = ee({
      title: "",
      conceptSetId: "",
      typeContainer: s || j.WORKSPACE,
      parentId: a || null
    }), { status: y, conceptSets: D, setParams: L, conceptSetCreation: b, conceptSet: M } = Wa(s, a), B = (O) => /* @__PURE__ */ r.jsxs(_, { container: !0, spacing: 1, children: [
      /* @__PURE__ */ r.jsxs(_, { item: !0, xs: 12, children: [
        "Concept set ",
        /* @__PURE__ */ r.jsx("b", { children: M.name }),
        " successfully ",
        O
      ] }),
      /* @__PURE__ */ r.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
        xo,
        {
          to: E.typeContainer === j.WORKSPACE ? `/workspace/concept-sets/${M.id}` : `/study-manager/${E.parentId}/concept-sets/${M.id}`,
          children: /* @__PURE__ */ r.jsxs("b", { children: [
            "Navigate to concept set ",
            ">>"
          ] })
        }
      ) })
    ] });
    J(() => {
      (y === Fe.CREATED_SUCCESS || y === Fe.UPDATED_SUCCESS) && (c({
        message: B(
          y === Fe.CREATED_SUCCESS ? "created" : "updated"
        ),
        variant: "success"
      }), m(null), i());
    }, [y, M]);
    const g = k(() => (d === Ve.NEW ? E.title : E.conceptSetId) && (E.typeContainer === j.STUDY ? E.parentId : !0), [E]);
    return /* @__PURE__ */ r.jsx(za, { children: /* @__PURE__ */ r.jsxs(_, { container: !0, children: [
      !d && /* @__PURE__ */ r.jsx(_, { container: !0, item: !0, xs: 12, children: /* @__PURE__ */ r.jsxs(_, { item: !0, xs: 12, textAlign: "right", children: [
        /* @__PURE__ */ r.jsx(
          ae,
          {
            variant: "outlined",
            onClick: () => m(Ve.EXIST),
            disabled: !D.length || p,
            startIcon: y === P.IN_PROGRESS ? /* @__PURE__ */ r.jsx(Ie, { size: 14, color: "secondary" }) : /* @__PURE__ */ r.jsx(se, { iconName: "add" }),
            sx: { mr: 1 },
            children: "Add to existing concept set"
          }
        ),
        /* @__PURE__ */ r.jsx(
          ae,
          {
            variant: "outlined",
            onClick: () => m(Ve.NEW),
            startIcon: /* @__PURE__ */ r.jsx(se, { iconName: "add" }),
            disabled: p,
            children: "Create new concept set"
          }
        ),
        o && /* @__PURE__ */ r.jsx(o, {})
      ] }) }),
      d && /* @__PURE__ */ r.jsxs(_, { container: !0, item: !0, xs: 12, children: [
        /* @__PURE__ */ r.jsx(_, { item: !0, flexGrow: 1, children: /* @__PURE__ */ r.jsxs(_, { container: !0, spacing: 2, children: [
          /* @__PURE__ */ r.jsxs(
            _,
            {
              container: !0,
              item: !0,
              xs: 12,
              md: 4,
              spacing: 1,
              alignItems: "center",
              children: [
                /* @__PURE__ */ r.jsx(
                  _,
                  {
                    item: !0,
                    className: "title-saving",
                    width: { xs: 90, md: "auto" },
                    children: "Container"
                  }
                ),
                /* @__PURE__ */ r.jsx(_, { item: !0, flexGrow: 1, children: /* @__PURE__ */ r.jsx(
                  mn,
                  {
                    className: "exist-concept-set",
                    name: "exist-concept-set",
                    disablePortal: !0,
                    fullWidth: !0,
                    id: "exist-concept-set",
                    options: Zs.filter((O) => O.value !== "ATLAS"),
                    value: E.typeContainer,
                    placeholder: "Select concept set...",
                    onChange: (O) => {
                      L(O, null), h({
                        ...E,
                        title: "",
                        conceptSetId: "",
                        typeContainer: O,
                        parentId: null
                      });
                    }
                  }
                ) })
              ]
            }
          ),
          E.typeContainer === j.STUDY && /* @__PURE__ */ r.jsxs(
            _,
            {
              container: !0,
              item: !0,
              xs: 12,
              md: 4,
              spacing: 1,
              alignItems: "center",
              children: [
                /* @__PURE__ */ r.jsx(
                  _,
                  {
                    item: !0,
                    className: "title-saving",
                    width: { xs: 90, md: "auto" },
                    children: "Study"
                  }
                ),
                /* @__PURE__ */ r.jsx(_, { item: !0, flexGrow: 1, children: /* @__PURE__ */ r.jsx(
                  n.study,
                  {
                    type: "component",
                    name: "user-studies-list",
                    subModules: n,
                    config: {
                      onChange: (O) => {
                        O && (L(E.typeContainer, O.id), h({
                          ...E,
                          title: "",
                          conceptSetId: "",
                          parentId: O.id
                        }));
                      },
                      studyInitialId: a
                    }
                  }
                ) })
              ]
            }
          ),
          d === Ve.EXIST && /* @__PURE__ */ r.jsx(
            Va,
            {
              typeContainer: E.typeContainer,
              parentId: E.parentId,
              conceptSets: D,
              status: y,
              existConceptSetId: E.conceptSetId,
              setState: h
            }
          ),
          d === Ve.NEW && /* @__PURE__ */ r.jsx(
            Fa,
            {
              setState: h,
              title: E.title
            }
          )
        ] }) }),
        /* @__PURE__ */ r.jsxs(
          _,
          {
            item: !0,
            width: { xs: "100%", md: 200 },
            textAlign: "right",
            mt: { md: 0, xs: 2 },
            children: [
              /* @__PURE__ */ r.jsx(
                ae,
                {
                  variant: "outlined",
                  onClick: () => m(null),
                  startIcon: /* @__PURE__ */ r.jsx(se, { iconName: "close" }),
                  children: "Cancel"
                }
              ),
              /* @__PURE__ */ r.jsx(
                ae,
                {
                  onClick: () => {
                    b(E, d, t);
                  },
                  disabled: y === Fe.IN_PROGRESS_CREATION || !g,
                  variant: "contained",
                  color: "success",
                  startIcon: y === Fe.IN_PROGRESS_CREATION ? /* @__PURE__ */ r.jsx(Ie, { size: 16 }) : /* @__PURE__ */ r.jsx(se, { iconName: "submit" }),
                  sx: { ml: 1 },
                  children: "Save"
                }
              )
            ]
          }
        )
      ] })
    ] }) });
  }
), kt = (e) => {
  const {
    message: t = "Included concepts",
    count: n = 0,
    isLoading: s,
    items: a,
    getCount: o,
    versionId: i,
    type: l,
    hideZeroCount: p
  } = e, c = nt(!1), d = nt(null), m = V(
    async (E, h) => {
      if (c.current) {
        d.current = E;
        return;
      }
      c.current = !0, d.current = null;
      try {
        await (o == null ? void 0 : o(h));
      } catch (y) {
        console.error(y);
      } finally {
        c.current = !1, d.current && (d.current = null, await m(d.current, h));
      }
    },
    [o]
  );
  return J(() => {
    m(a, l);
  }, [a, i]), /* @__PURE__ */ r.jsx(
    Re,
    {
      title: t,
      count: n.toLocaleString(),
      status: s ? P.IN_PROGRESS : P.SUCCESS,
      hideZeroCount: p
    }
  );
}, Ya = {
  entityNavigationPanel: (e, t, n, s, a) => [
    {
      value: we.EXPRESSION,
      title: "Expression",
      onTabClick: e
    },
    {
      value: we.INCLUDED_CONCEPTS,
      title: /* @__PURE__ */ r.jsx(
        kt,
        {
          count: t.includedConcepts,
          isLoading: t.loadingCountsIncludedConcepts,
          items: s,
          type: ve.INCLUDED_CONCEPTS,
          getCount: n,
          hideZeroCount: !a
        }
      ),
      onTabClick: e
    },
    {
      value: we.INCLUDED_SOURCE_CODES,
      title: /* @__PURE__ */ r.jsx(
        kt,
        {
          count: t.includedSourceCodes,
          isLoading: t.loadingCountsSourceCodes,
          items: s,
          message: "Included source codes",
          type: ve.INCLUDED_SOURCE_CODES,
          getCount: n,
          hideZeroCount: !a
        }
      ),
      onTabClick: e
    }
  ]
}, qa = {
  items: {},
  counts: {
    includedConcepts: 0,
    includedSourceCodes: 0,
    status: P.INITIAL,
    loadingCountsSourceCodes: !1,
    loadingCountsIncludedConcepts: !1
  },
  error: null,
  status: P.INITIAL
};
var Se = /* @__PURE__ */ ((e) => (e.CHECK_CONCEPT_SET = "CHECK_CONCEPT_SET", e.REMOVE_CONCEPT_SET_ITEM = "REMOVE_CONCEPT_SET_ITEM", e.CREATE_CONCEPT_SET_ITEM = "CREATE_CONCEPT_SET_ITEM", e.UPDATE_CONCEPT_SET_ITEMS = "UPDATE_CONCEPT_SET_ITEMS", e.SET_COUNT_REQUEST = "SET_COUNT_REQUEST", e.SET_COUNT_REQUEST_DONE = "SET_COUNT_REQUEST_DONE", e))(Se || {});
const Ha = (e, t) => Cn(e, (n) => {
  switch (t.type) {
    case Se.CREATE_CONCEPT_SET_ITEM:
      n.status = P.SUCCESS;
      break;
    case Se.UPDATE_CONCEPT_SET_ITEMS:
      n.items = t.payload, n.status = P.SUCCESS;
      break;
    case Se.REMOVE_CONCEPT_SET_ITEM: {
      Ys(t.payload, (s) => s.concept.CONCEPT_ID), n.status = P.SUCCESS;
      break;
    }
    case Se.SET_COUNT_REQUEST:
      n.counts.status = P.IN_PROGRESS, t.payload == ve.INCLUDED_CONCEPTS ? n.counts.loadingCountsIncludedConcepts = !0 : n.counts.loadingCountsSourceCodes = !0;
      break;
    case Se.SET_COUNT_REQUEST_DONE:
      if (n.counts.status = P.SUCCESS, t.payload.reset) {
        n.counts.includedConcepts = 0, n.counts.includedSourceCodes = 0, n.counts.loadingCountsIncludedConcepts = !1, n.counts.loadingCountsSourceCodes = !1;
        break;
      }
      t.payload.typeOfIncluded == ve.INCLUDED_CONCEPTS ? (n.counts.loadingCountsIncludedConcepts = !1, n.counts.includedConcepts = t.payload.count) : (n.counts.loadingCountsSourceCodes = !1, n.counts.includedSourceCodes = t.payload.count);
  }
}), Ja = (e, t) => {
  const [n, s] = un(
    Ha,
    {
      ...qa,
      items: t
    }
  ), a = (c) => {
    s({
      type: Se.UPDATE_CONCEPT_SET_ITEMS,
      payload: c
    });
  }, o = V(() => {
    if (!n.items || !t)
      return [];
    const c = {
      items: Ge(t)
    }, d = {
      items: Ge(n.items)
    }, m = zt(c, d);
    return Br(m, d.items);
  }, [n.items]), i = V(
    (c, d) => {
      try {
        return Pr(d, c, e.uuid, {
          delta: o()
        });
      } catch (m) {
        console.error(m);
      }
    },
    [n.items]
  ), l = V(
    (c, d) => {
      try {
        return Dr(
          d,
          c,
          e.uuid,
          {
            delta: o()
          }
        );
      } catch (m) {
        console.error(m);
      }
    },
    [n.items]
  ), p = V(
    async (c) => {
      if (Object.values(n.items || {}).length) {
        s({
          type: Se.SET_COUNT_REQUEST,
          payload: c
        });
        try {
          if (!e.uuid) {
            s({
              type: Se.SET_COUNT_REQUEST_DONE,
              payload: {
                typeOfIncluded: c,
                count: 0
              }
            });
            return;
          }
          const d = c == ve.INCLUDED_CONCEPTS ? await jr(e.uuid, {
            delta: o()
          }) : await wr(e.uuid, {
            delta: o()
          });
          s({
            type: Se.SET_COUNT_REQUEST_DONE,
            payload: {
              typeOfIncluded: c,
              count: d
            }
          });
        } catch {
          s({
            type: Se.SET_COUNT_REQUEST_DONE,
            payload: {
              typeOfIncluded: c,
              count: 0
            }
          });
        }
      } else
        s({
          type: Se.SET_COUNT_REQUEST_DONE,
          payload: {
            reset: !0
          }
        });
    },
    [n.items]
  );
  return {
    ...n,
    getCountIncluded: p,
    updateConceptSetItems: a,
    getIncludedConcepts: i,
    getIncludedConceptsFilters: l
  };
}, Ka = (e) => {
  const {
    conceptSet: t,
    conceptSetItems: n = [],
    subModules: s,
    updateModel: a,
    // path,
    viewMode: o
  } = e, [i, l] = ee(
    we.EXPRESSION
  ), { entityNavigationPanel: p } = Ya, c = Er(), [d, m] = ee("");
  J(() => {
    m(
      c.pathname[0] === "/" ? c.pathname.substring(1) : c.pathname
    );
  }, []);
  const E = k(() => mt(n), [n]), {
    counts: h,
    items: y,
    status: D,
    getCountIncluded: L,
    getIncludedConcepts: b,
    updateConceptSetItems: M,
    getIncludedConceptsFilters: B
  } = Ja(t, E), g = k(() => p(
    l,
    h,
    L,
    y,
    t.uuid
  ), [h, y, t]), O = (N) => {
    o || M(N);
  };
  J(() => {
    !o && D !== P.INITIAL && a(At(y));
  }, [y, D, o]);
  const T = () => {
    l(we.EXPRESSION);
  };
  return /* @__PURE__ */ r.jsxs(_, { container: !0, children: [
    /* @__PURE__ */ r.jsxs(
      _,
      {
        item: !0,
        xs: 12,
        bgcolor: "white",
        sx: { borderTopRightRadius: "2px", borderTopLeftRadius: "2px" },
        children: [
          /* @__PURE__ */ r.jsx(En, { tabs: g, active: i, secondary: !0 }),
          /* @__PURE__ */ r.jsx(fn, {})
        ]
      }
    ),
    /* @__PURE__ */ r.jsx(_, { item: !0, xs: 12, mt: 2, children: D === P.IN_PROGRESS ? /* @__PURE__ */ r.jsx(Pe, { children: /* @__PURE__ */ r.jsx(Ie, { size: 32 }) }) : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      i == we.EXPRESSION && /* @__PURE__ */ r.jsx(
        s.vocabulary,
        {
          type: "component",
          name: "expression-concepts",
          path: d,
          subModules: s,
          config: {
            concepts: y,
            onChange: O,
            viewMode: o,
            mode: "embedded"
          }
        }
      ),
      i == we.INCLUDED_CONCEPTS && /* @__PURE__ */ r.jsx(
        s.vocabulary,
        {
          type: "component",
          name: "included-concepts",
          subModules: s,
          path: d,
          config: {
            concepts: y,
            methodIncluded: b,
            filtersIncluded: B,
            onChange: O,
            onFinish: T,
            viewMode: o
          }
        }
      ),
      i == we.INCLUDED_SOURCE_CODES && /* @__PURE__ */ r.jsx(
        s.vocabulary,
        {
          type: "component",
          name: "included-concepts-source-codes",
          subModules: s,
          path: d,
          config: {
            concepts: y,
            methodIncluded: b,
            filtersIncluded: B,
            onChange: O,
            onFinish: T,
            viewMode: o
          }
        }
      )
    ] }) })
  ] });
}, Qa = (e) => {
  var t, n;
  return (e == null ? void 0 : e.ordinal) ?? ((t = e == null ? void 0 : e.data) == null ? void 0 : t.versionOrdinal) ?? ((n = e == null ? void 0 : e.data) == null ? void 0 : n.version) ?? (e == null ? void 0 : e.versionOrdinal) ?? (e == null ? void 0 : e.version) ?? null;
}, Xa = (e) => {
  if (!e)
    return "none";
  const t = !!(e.referenceId || e.versionId || e.currentVersionId);
  return !t && !e.terminated ? "none" : e.terminated || t && !e.currentVersionId ? "archived" : e.versionId && e.currentVersionId && e.currentVersionId !== e.versionId ? "outdated" : "none";
}, It = ({ label: e, color: t, icon: n }) => {
  const s = {
    warning: {
      backgroundColor: "#fff1dd",
      color: "#f2a53a"
    },
    info: {
      backgroundColor: "#d6eafb",
      color: "#64a7df"
    },
    default: {
      backgroundColor: "#dfdfdf",
      color: "#8f8f8f"
    }
  };
  return /* @__PURE__ */ r.jsxs(
    Ce,
    {
      display: "inline-flex",
      alignItems: "center",
      px: 1.25,
      height: 26,
      borderRadius: 1,
      sx: {
        ...s[t],
        lineHeight: 1
      },
      children: [
        n,
        /* @__PURE__ */ r.jsx(xe, { component: "span", fontSize: 14, sx: { lineHeight: 1 }, children: e })
      ]
    }
  );
}, ar = /* @__PURE__ */ r.jsx(
  Ce,
  {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    mr: 0.75,
    width: 16,
    height: 16,
    borderRadius: "50%",
    sx: {
      border: "2px solid currentColor"
    },
    children: /* @__PURE__ */ r.jsx(
      se,
      {
        iconName: "info",
        sx: {
          color: "inherit",
          fontSize: 16,
          "& circle": {
            fill: "transparent",
            fillOpacity: 1
          }
        }
      }
    )
  }
), Za = /* @__PURE__ */ r.jsx(se, { iconName: "reload", sx: { color: "inherit", fontSize: 16, mr: 0.75 } }), ei = ({ conceptSet: e, viewMode: t = !1, onRefresh: n }) => {
  const s = k(() => Xa(e), [e]), [a, o] = ee(null);
  if (J(() => {
    let h = !0;
    return (s === "outdated" || s === "archived") && ((e == null ? void 0 : e.versionOrdinal) === void 0 || (e == null ? void 0 : e.versionOrdinal) === null) && ((e == null ? void 0 : e.version) === void 0 || (e == null ? void 0 : e.version) === null) && (e != null && e.versionId) && Lr(e.versionId).then((y) => {
      const D = Qa(y);
      h && D !== null && o(D);
    }).catch(() => {
    }), () => {
      h = !1;
    };
  }, [
    e == null ? void 0 : e.version,
    e == null ? void 0 : e.versionId,
    e == null ? void 0 : e.versionOrdinal,
    s
  ]), !e || s === "none")
    return null;
  const i = e.versionOrdinal ?? e.version ?? a, l = i != null, p = !!(!t && s === "outdated" && n && e.currentVersionId), c = e.currentVersionOrdinal, d = /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    "Newer version exists",
    c != null ? ` (latest version: ${c})` : "",
    ",",
    /* @__PURE__ */ r.jsx("br", {}),
    " would you like to REFRESH it?"
  ] }), m = (h) => {
    h.preventDefault(), h.stopPropagation();
  }, E = (h) => {
    h.preventDefault(), h.stopPropagation(), n == null || n(e);
  };
  return /* @__PURE__ */ r.jsxs(
    Ce,
    {
      display: "inline-flex",
      alignItems: "center",
      flexWrap: "nowrap",
      ml: 1.5,
      sx: {
        whiteSpace: "nowrap",
        alignSelf: "center",
        lineHeight: 1
      },
      children: [
        l && /* @__PURE__ */ r.jsxs(
          xe,
          {
            variant: "subtitle1",
            component: "i",
            sx: { mr: 2, fontWeight: 400, whiteSpace: "nowrap" },
            children: [
              "( Version: ",
              i,
              " )"
            ]
          }
        ),
        s === "archived" && /* @__PURE__ */ r.jsx(
          It,
          {
            color: "default",
            label: "Archived",
            icon: /* @__PURE__ */ r.jsx(
              se,
              {
                iconName: "terminated",
                sx: { color: "inherit", fontSize: 16, mr: 0.75 }
              }
            )
          }
        ),
        s === "outdated" && (p ? /* @__PURE__ */ r.jsx(pt, { text: d, children: /* @__PURE__ */ r.jsxs(
          Ce,
          {
            role: "button",
            tabIndex: 0,
            onClick: E,
            onKeyDown: (h) => {
              (h.key === "Enter" || h.key === " ") && E(h);
            },
            onMouseDown: m,
            onPointerDown: m,
            onTouchStart: m,
            sx: {
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              lineHeight: 1,
              ".refresh-chip": {
                display: "none"
              },
              "&:hover": {
                ".outdated-chip": {
                  display: "none"
                },
                ".refresh-chip": {
                  display: "inline-flex"
                }
              }
            },
            children: [
              /* @__PURE__ */ r.jsx(Ce, { className: "outdated-chip", sx: { display: "inline-flex" }, children: /* @__PURE__ */ r.jsx(
                It,
                {
                  color: "warning",
                  label: "Outdated",
                  icon: ar
                }
              ) }),
              /* @__PURE__ */ r.jsx(Ce, { className: "refresh-chip", sx: { display: "inline-flex" }, children: /* @__PURE__ */ r.jsx(It, { color: "info", label: "Refresh", icon: Za }) })
            ]
          }
        ) }) : /* @__PURE__ */ r.jsx(It, { color: "warning", label: "Outdated", icon: ar }))
      ]
    }
  );
}, ti = (e) => [
  {
    value: "ITEMS",
    title: "Concept Set Expression",
    onTabClick: e
  },
  {
    value: "CONCEPT_IDS",
    title: "Expression Concept Identifiers",
    onTabClick: e
  },
  {
    value: "CONCEPT_INCLUDED_IDS",
    title: "Included Concept Identifiers",
    onTabClick: e
  },
  {
    value: "CONCEPT_INCLUDED_CODES",
    title: "Included Concept Codes (Source)",
    onTabClick: e
  }
], zr = Le((e) => {
  const { id: t, title: n = "" } = e, [s, a] = ee("ITEMS"), {
    exportConceptSet: o,
    exportConceptSetIds: i,
    exportConceptSetCodes: l,
    statusExportConceptSet: p,
    statusExportConceptSetIds: c,
    getExportConceptSet: d
  } = Rs(Nt.CONCEPT_SET, t, null), m = k(() => {
    var B;
    if (o && p === P.SUCCESS) {
      const g = ((B = o == null ? void 0 : o.expression) == null ? void 0 : B.items) || (o == null ? void 0 : o.items) || {};
      return {
        expression: {
          items: g
        },
        conceptIds: Object.values(g || {}).map(
          (O) => {
            var T;
            return O.conceptId || ((T = O.concept) == null ? void 0 : T.CONCEPT_ID);
          }
        )
      };
    }
  }, [o]), E = k(
    () => m == null ? void 0 : m.expression,
    [m == null ? void 0 : m.expression]
  ), h = k(
    () => m && m.conceptIds.join(", "),
    [m == null ? void 0 : m.conceptIds]
  ), y = k(
    () => i && c === P.SUCCESS && i.join(", "),
    [i]
  ), D = k(
    () => l && c === P.SUCCESS && l.join(", "),
    [l]
  ), L = k(
    () => qn(ke.JSON),
    []
  ), b = k(
    () => qn(ke.TXT),
    []
  ), M = k(() => ti(a), []);
  return J(() => {
    d("atlas");
  }, []), /* @__PURE__ */ r.jsxs(_, { container: !0, children: [
    /* @__PURE__ */ r.jsxs(_, { item: !0, xs: 12, children: [
      /* @__PURE__ */ r.jsx(En, { tabs: M, active: s, secondary: !0 }),
      /* @__PURE__ */ r.jsx(fn, {})
    ] }),
    /* @__PURE__ */ r.jsxs(_, { item: !0, xs: 12, p: 2, children: [
      s === "ITEMS" && /* @__PURE__ */ r.jsx(r.Fragment, { children: p === P.SUCCESS && E ? /* @__PURE__ */ r.jsx(
        Tt,
        {
          data: E,
          fileName: n,
          title: "Concept Set Expression",
          language: L,
          fileExtension: ke.JSON,
          contentType: ut.APPLICATION_JSON,
          readOnly: !0,
          height: 450,
          editorOptions: {
            wrappingStrategy: "simple"
          }
        }
      ) : /* @__PURE__ */ r.jsx(Pe, { children: /* @__PURE__ */ r.jsx(Ie, { size: 32 }) }) }),
      s === "CONCEPT_IDS" && /* @__PURE__ */ r.jsx(r.Fragment, { children: h && /* @__PURE__ */ r.jsx(
        Tt,
        {
          data: h,
          fileName: `${n} (Expression Concept Identifiers)`,
          title: "Expression Concept Identifiers",
          tooltipText: "Expression Concept Identifiers copied to clipboard!",
          contentType: ut.APPLICATION_TEXT,
          fileExtension: ke.TXT,
          language: b,
          height: 450,
          containerStyles: {
            paddingTop: 0
          },
          editorOptions: {
            wrappingStrategy: "simple"
          },
          readOnly: !0
        }
      ) }),
      s === "CONCEPT_INCLUDED_IDS" && /* @__PURE__ */ r.jsx(r.Fragment, { children: y && /* @__PURE__ */ r.jsx(
        Tt,
        {
          data: y,
          fileName: `${n} (Included Concept Identifiers)`,
          title: "Included Concept Identifiers",
          tooltipText: "Included Concept Identifiers copied to clipboard!",
          contentType: ut.APPLICATION_TEXT,
          fileExtension: ke.TXT,
          language: b,
          height: 450,
          containerStyles: {
            paddingTop: 0
          },
          editorOptions: {
            wrappingStrategy: "simple"
          },
          readOnly: !0
        }
      ) }),
      s === "CONCEPT_INCLUDED_CODES" && /* @__PURE__ */ r.jsx(r.Fragment, { children: D && /* @__PURE__ */ r.jsx(
        Tt,
        {
          data: D,
          fileName: `${n} (Included Concept Codes (Source))`,
          title: "Included Concept Codes (Source)",
          tooltipText: "Included Concept Codes (Source) copied to clipboard!",
          contentType: ut.APPLICATION_TEXT,
          fileExtension: ke.TXT,
          language: b,
          height: 450,
          containerStyles: {
            paddingTop: 0
          },
          editorOptions: {
            wrappingStrategy: "simple"
          },
          readOnly: !0
        }
      ) })
    ] })
  ] });
}), ni = (e) => {
  const {
    conceptSets: t,
    onChange: n,
    conceptSetNameErrors: s,
    onConceptSetNameSubmit: a,
    onConceptSetNameCancel: o,
    subModules: i,
    typeContainer: l,
    parentId: p,
    viewMode: c,
    analysisMode: d,
    exportConceptSet: m,
    circleMode: E,
    refreshConceptSetReference: h,
    hideSectionContent: y,
    renderSectionTitleAddon: D,
    onEditSection: L,
    onAddConceptSet: b,
    hideAddConceptSetAction: M = !1,
    hideCopySectionAction: B = !1,
    hideEditSectionAction: g = !1
  } = e, [O, T] = ee(!1), { openModal: N, closeModal: K } = Te(qe), {
    sections: z,
    addSection: ne,
    copySection: G,
    updateSection: S,
    removeSection: $,
    exportSection: Y,
    syncSections: R
  } = As(t || []), de = V(
    (u) => ({
      id: u.id,
      name: u.name,
      uuid: u == null ? void 0 : u.uuid,
      expression: u.expression,
      referenceId: u == null ? void 0 : u.referenceId,
      externalId: u == null ? void 0 : u.externalId,
      versionId: u == null ? void 0 : u.versionId,
      currentVersionId: u == null ? void 0 : u.currentVersionId,
      version: u == null ? void 0 : u.version,
      versionOrdinal: u == null ? void 0 : u.versionOrdinal,
      currentVersionOrdinal: u == null ? void 0 : u.currentVersionOrdinal,
      terminated: u == null ? void 0 : u.terminated
    }),
    []
  ), W = V(
    (u) => ({
      id: u.id,
      name: u.name,
      uuid: u == null ? void 0 : u.uuid,
      expression: u.expression,
      referenceId: u == null ? void 0 : u.referenceId,
      externalId: u == null ? void 0 : u.externalId,
      versionId: u == null ? void 0 : u.versionId,
      currentVersionId: u == null ? void 0 : u.currentVersionId,
      version: u == null ? void 0 : u.version,
      versionOrdinal: u == null ? void 0 : u.versionOrdinal,
      currentVersionOrdinal: u == null ? void 0 : u.currentVersionOrdinal,
      terminated: u == null ? void 0 : u.terminated
    }),
    []
  ), he = k(
    () => z.map(
      (u) => de(u)
    ),
    [z, de]
  ), ue = k(
    () => z.map(
      (u) => W(u)
    ),
    [z, W]
  );
  k(
    () => (t || []).map(
      (u) => de(u)
    ),
    [de, t]
  );
  const C = k(
    () => (t || []).map(
      (u) => W(u)
    ),
    [W, t]
  ), w = nt(ue), F = nt(!1);
  J(() => {
    w.current = ue;
  }, [ue]), J(() => {
    jt(w.current, C) || (F.current = !0, R(t || []));
  }, [C, R, t]);
  const Q = (u) => {
    N(
      () => /* @__PURE__ */ r.jsx(
        Cr,
        {
          id: u.uuid,
          name: u.name,
          parentId: p,
          currentContainer: l,
          subModules: i,
          jsonImportTabName: "Concept Set Items",
          createCopyMethod: $r,
          typeEntity: "concept-sets",
          entityAtlas: Ct.CS,
          defaultResolution: te.CREATE_NEW_OBJECT,
          hideConflictResolutionControls: !0,
          validateName: async (v) => v.typeContainer === j.WORKSPACE ? ze(
            j.WORKSPACE,
            v.name
          ) : v.typeContainer === j.STUDY ? v.studyId ? ze(
            j.STUDY,
            v.name,
            String(v.studyId)
          ) : {
            isValid: !1,
            message: "Study is required."
          } : { isValid: !0 },
          onChange: () => {
            K();
          },
          exportJson: /* @__PURE__ */ r.jsx(zr, { id: u.uuid || u.id, title: u.name }),
          customAction: /* @__PURE__ */ r.jsx(
            "a",
            {
              href: `/api/conceptset/${u.uuid}/included/csv-zip`,
              target: "_blank",
              children: /* @__PURE__ */ r.jsx(
                ae,
                {
                  variant: "contained",
                  color: "success",
                  size: "small",
                  startIcon: /* @__PURE__ */ r.jsx(se, { iconName: "export" }),
                  children: "Export to CSV"
                }
              )
            }
          )
        }
      ),
      "Export concept set",
      {
        closeOnClickOutside: !0,
        onClose: K
      }
    );
  };
  J(() => {
    if (jt(
      ue,
      C
    )) {
      F.current = !1;
      return;
    }
    F.current || n == null || n(he);
  }, [
    d,
    he,
    ue,
    C,
    n
  ]);
  const ce = V(
    async (u) => {
      h && await h(u);
    },
    [h]
  ), oe = async () => {
    if (!b) {
      ne({
        id: null,
        name: "New Concept set",
        expression: { items: [] }
      });
      return;
    }
    T(!0);
    try {
      const u = await b();
      u && ne(u);
    } finally {
      T(!1);
    }
  };
  return /* @__PURE__ */ r.jsx(Be, { children: /* @__PURE__ */ r.jsx(
    $t,
    {
      outlined: !0,
      title: "Concept sets",
      actions: c ? void 0 : /* @__PURE__ */ r.jsxs(Ce, { display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ r.jsx(
          kr,
          {
            defaultValue: "Import concept set",
            localImport: !1,
            importMultiSelect: !0,
            conceptSets: t,
            typeContainer: l,
            parentId: p,
            subModules: i,
            simpleButtonMode: !0,
            dense: !1,
            circleMode: E,
            onUpdate: (u) => {
              ne(u);
            }
          }
        ),
        !M && /* @__PURE__ */ r.jsx(
          ae,
          {
            variant: "contained",
            color: "info",
            onClick: oe,
            disabled: O,
            startIcon: O ? /* @__PURE__ */ r.jsx(Ie, { size: 16 }) : /* @__PURE__ */ r.jsx(
              se,
              {
                iconName: "add",
                sx: { "&.MuiSvgIcon-root": { fontSize: 16 } }
              }
            ),
            sx: { ml: 2 },
            children: "Add concept set"
          }
        )
      ] }),
      children: /* @__PURE__ */ r.jsx(_, { container: !0, children: /* @__PURE__ */ r.jsx(_, { container: !0, spacing: 1, alignItems: "center", children: z.length > 0 && z.map(
        (u, v) => {
          const X = (u == null ? void 0 : u.uuid) ?? (u == null ? void 0 : u.id) ?? (u == null ? void 0 : u.referenceId) ?? `${(u == null ? void 0 : u.name) || "section"}-${v}`;
          return /* @__PURE__ */ r.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
            uo,
            {
              index: v,
              viewMode: c,
              item: u,
              titleMeta: D ? null : /* @__PURE__ */ r.jsx(
                ei,
                {
                  conceptSet: u,
                  viewMode: c,
                  onRefresh: (q) => ce(
                    q
                  )
                }
              ),
              copySection: G,
              onCancelSectionName: (q) => {
                o == null || o(q);
              },
              updateSection: async (q, ie, fe) => ie === "name" && (typeof fe != "string" || !(await (a == null ? void 0 : a(
                q,
                fe
              )) ?? !0)) ? !1 : (S(q, ie, fe), !0),
              removeSection: $,
              nameError: s == null ? void 0 : s[String(v)],
              exportSection: (q) => {
                const ie = Y(q);
                Q(ie);
              },
              isExport: m,
              bodyViewMode: y,
              disableNameEdit: y,
              titleAddon: D == null ? void 0 : D(
                u,
                v,
                {
                  onRefreshReference: (q) => ce(q)
                }
              ),
              onEdit: L ? (q, ie) => {
                L(
                  q,
                  ie
                );
              } : void 0,
              hideCopyAction: B,
              hideEditAction: g,
              children: /* @__PURE__ */ r.jsx(
                Ka,
                {
                  viewMode: c || y,
                  conceptSet: u,
                  conceptSetItems: u.expression.items,
                  subModules: i,
                  updateModel: (q) => {
                    S(v, "expression", {
                      items: q
                    });
                  }
                }
              )
            }
          ) }, String(X));
        }
      ) }) })
    }
  ) });
}, ri = (e) => {
  var a;
  const { conceptSets: t, conceptSetId: n } = e, s = k(
    () => Xt(n, t || []),
    [n, t]
  );
  return /* @__PURE__ */ r.jsx(_, { container: !0, children: /* @__PURE__ */ r.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
    Ur,
    {
      currentConceptSet: {
        ...s,
        expression: {
          items: mt(
            ((a = s == null ? void 0 : s.expression) == null ? void 0 : a.items) || []
          )
        }
      },
      conceptSets: t.map((o) => {
        var i;
        return {
          ...o,
          expression: {
            items: mt(
              ((i = o == null ? void 0 : o.expression) == null ? void 0 : i.items) || []
            )
          }
        };
      }),
      viewMode: !0
    }
  ) }) });
}, si = "&filter.metadata.subject=CONCEPT_SET", ir = te.CREATE_NEW_VERSION, oi = te.CREATE_NEW_OBJECT, ai = "Fully identical concept sets will not be created, instead existing ones will be re-used. Concept sets with the same name will create a new version of the existing ones and Cohort design will reference these newly created versions. Previously created concept-sets, which are not used anywhere else will be deleted(archived).", ii = "New Concept Set(s) will be created, even if identical Concept Set(s) exist.", dt = (e) => e.trim().replace(/^['"]|['"]$/g, "").replace(/^\[+/, "").replace(/\]+$/, "").trim(), vt = (e) => {
  if (Array.isArray(e))
    return e.map((t) => dt(String(t))).filter(Boolean);
  if (typeof e == "string") {
    const t = e.trim();
    if (!t) return [];
    try {
      const n = JSON.parse(t);
      if (Array.isArray(n))
        return n.map((s) => dt(String(s))).filter(Boolean);
    } catch {
    }
    if (t.startsWith("[") && t.endsWith("]")) {
      const n = t.slice(1, -1).trim();
      return n ? n.split(",").map(dt).filter(Boolean) : [];
    }
    return t.includes(",") ? t.split(",").map(dt).filter(Boolean) : [dt(t)].filter(Boolean);
  }
  return [];
}, ci = (e) => {
  if (!e) return {};
  if (typeof e == "string") {
    try {
      const t = JSON.parse(e);
      if (t && typeof t == "object" && !Array.isArray(t))
        return t;
    } catch {
      return { Description: e };
    }
    return { Description: e };
  }
  return e;
}, Qt = (e) => typeof e == "string" ? e : e.name, cr = (e) => {
  if (typeof e == "boolean")
    return e;
  if (typeof e == "string") {
    const t = e.trim().toLowerCase();
    if (t === "true")
      return !0;
    if (t === "false")
      return !1;
  }
}, _t = (e) => {
  if (typeof e == "number" && Number.isFinite(e))
    return e;
  if (typeof e == "string" && e.trim() !== "") {
    const t = Number(e);
    if (Number.isFinite(t))
      return t;
  }
}, tt = (e, t) => {
  var a;
  const n = t.map((o) => o.toLowerCase()), s = e == null ? void 0 : e.find((o) => {
    var l, p;
    const i = (p = (l = o.attribute) == null ? void 0 : l.name) == null ? void 0 : p.toLowerCase();
    return i ? n.includes(i) : !1;
  });
  return ((a = s == null ? void 0 : s.value) == null ? void 0 : a.trim()) || "";
}, li = (e, t) => {
  const n = _t(e["Search precision"]) ?? _t(
    tt(t, [
      "Search precision",
      "ai-search-precision"
    ])
  );
  if (n !== void 0 && n >= 0 && n < Rt.length)
    return n;
  const s = cr(e["~ai_skip_vector_search"]) ?? cr(
    tt(t, [
      "~ai_skip_vector_search",
      "ai_skip_vector_search",
      "ai-skip-vector-search"
    ])
  ), a = _t(e["~vector_search_result_limit"]) ?? _t(
    tt(t, [
      "~vector_search_result_limit",
      "vector_search_result_limit",
      "ai-vector-search-result-limit"
    ])
  ), o = Rt.findIndex(
    (i) => i.skipVectorSearch === s && i.vectorSearchResultLimit === a
  );
  return o >= 0 ? o : 0;
}, di = le.div`
  padding-top: 12px;
  border-top: 1px solid ${({ theme: e }) => e.palette.backgroundColor.dark};
`, ui = le.label`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: rgb(133, 133, 133);
  font-size: 15px;
  font-weight: 500;

  .app-checkbox {
    margin-right: 10px;
  }
`, Gr = Le(
  ({
    parentId: e,
    typeContainer: t,
    afterCreate: n,
    onCancel: s,
    onGenerateStart: a,
    onGenerateError: o,
    createMethod: i,
    entity: l,
    prompt: p,
    attributes: c
  }) => {
    var u, v, X, q, ie, fe;
    const { enqueueSnackbar: d } = st(), m = !!l, [E, h] = ee(!1), [y, D] = ee(""), [L, b] = ee(!1), M = nt(0), B = nt(!1), [g, O] = ee(ir), T = ci(p), N = (A, I) => vt(A).map((pe) => ({ name: (I == null ? void 0 : I.get(pe)) ?? pe, value: pe })), K = V(
      async (A, I) => {
        const [H, pe] = await Promise.all([
          Yo(si),
          wt(
            "filter.metadata.value.subject.id",
            A
          )
        ]), Ee = H.content.find(
          (Me) => Me.name === "ai-prompt"
        );
        if (!Ee)
          return;
        const me = pe.content.find(
          (Me) => {
            var _e;
            return ((_e = Me.attribute) == null ? void 0 : _e.name) === "ai-prompt";
          }
        ), Je = JSON.stringify({
          Description: I.description,
          Domain: I.domain,
          Vocabulary: I.vocabulary,
          "Standard concept": I.standardConcept,
          "Search precision": I.searchPrecision,
          "~ai_skip_vector_search": I.skipVectorSearch,
          "~vector_search_result_limit": I.vectorSearchResultLimit,
          "Conflict resolution": I.conflictResolution
        }), x = {
          attribute: { id: Ee.id },
          dataSourceId: A,
          value: Je
        };
        if (me != null && me.id) {
          await rn(x, me.id);
          return;
        }
        await nn(x);
      },
      []
    ), z = vt(T.Domain).length > 0 ? T.Domain : tt(c, ["Domain", "ai-domains"]), ne = vt(T.Vocabulary).length > 0 ? T.Vocabulary : tt(c, [
      "Vocabulary",
      "ai-vocabularies"
    ]), G = vt(T["Standard concept"]).length > 0 ? T["Standard concept"] : tt(c, [
      "Standard concept",
      "ai-standard-concepts"
    ]), [S, $] = ee({
      text: T.Description || "",
      concept_set_name: (l == null ? void 0 : l.name) || "",
      vocabulary: N(ne),
      domain: N(z),
      standard_concept: N(
        G,
        new Map(
          Array.from(eo, ([A, I]) => [
            A,
            I.caption
          ])
        )
      ),
      model_id: "",
      search_precision: li(T, c),
      suggestion: !1
    }), Y = js(i, e, l, "conceptset"), { options: R, status: de } = ws(), { options: W, status: he } = Ps(), ue = V(
      (A) => {
        const { name: I, value: H } = A.target;
        $((pe) => ({ ...pe, [I]: H }));
      },
      []
    ), C = V(
      (A, I) => {
        $((H) => ({ ...H, [A]: I }));
      },
      []
    ), w = V(
      async (A) => {
        if (!(E || Object.values(S).every(Ot))) {
          h(!0);
          try {
            if (!l) {
              const x = await ze(
                t,
                S.concept_set_name,
                e
              );
              if (!x.isValid) {
                D(x.message || ""), h(!1);
                return;
              }
            }
            D(""), a ? a() : d({
              message: l ? "Concept set regenerate in progress..." : "Concept set generate in progress...",
              variant: "success"
            });
            const I = Rt[S.search_precision] ?? Rt[0], H = S.domain.map((x) => x.value), pe = S.vocabulary.map((x) => x.value), Ee = S.standard_concept.map(
              (x) => x.value
            );
            let me = !1;
            const Je = await Y.generate(
              {
                title: S.concept_set_name,
                description: S.text,
                domain: H,
                vocabulary: pe,
                standardConcept: Ee,
                conflictResolution: A,
                skipVectorSearch: I.skipVectorSearch,
                vectorSearchResultLimit: I.vectorSearchResultLimit,
                suggestion: S.suggestion
              },
              (x) => {
                me = !0, n(x);
              }
            );
            try {
              await K(Je.id, {
                description: S.text,
                domain: H,
                vocabulary: pe,
                standardConcept: Ee,
                searchPrecision: S.search_precision,
                skipVectorSearch: I.skipVectorSearch,
                vectorSearchResultLimit: I.vectorSearchResultLimit,
                conflictResolution: A
              });
            } catch (x) {
              console.error("Error updating ai-prompt metadata:", x);
            }
            me || n(Je);
          } catch (I) {
            o == null || o(), d({
              message: "Concept set not created",
              variant: "error"
            }), console.error("Error:", I);
          } finally {
            h(!1);
          }
        }
      },
      [
        S,
        E,
        n,
        l,
        t,
        e,
        Y,
        K,
        d,
        a,
        o
      ]
    ), F = V(() => {
      O(ir), b(!0);
    }, []), Q = V(() => {
      b(!1), B.current = !1, Jt("dialog") >= M.current && window.history.back();
    }, []);
    J(() => {
      if (L && !B.current) {
        const A = Jt("dialog") + 1;
        M.current = A, Ds("dialog", A);
      }
      B.current = L;
    }, [L]), J(() => {
      const A = (I) => {
        L && Jt("dialog", I.state) < M.current && b(!1);
      };
      return window.addEventListener("popstate", A), () => {
        window.removeEventListener("popstate", A);
      };
    }, [L]);
    const ce = V(async () => {
      Q(), await w(g);
    }, [Q, g, w]), oe = V(() => {
      if (m) {
        F();
        return;
      }
      w(oi);
    }, [m, F, w]);
    return J(() => {
      if (he === P.SUCCESS) {
        const A = W.find((I) => I.isDefault);
        $((I) => ({ ...I, model_id: A == null ? void 0 : A.value }));
      }
    }, [he]), [P.INITIAL, P.IN_PROGRESS].includes(de) || [P.INITIAL, P.IN_PROGRESS].includes(he) ? /* @__PURE__ */ r.jsx(Pe, { children: /* @__PURE__ */ r.jsx(Ie, {}) }) : /* @__PURE__ */ r.jsxs(
      _,
      {
        container: !0,
        p: 2,
        sx: { width: "100%", maxWidth: "100%", overflowX: "hidden" },
        children: [
          /* @__PURE__ */ r.jsx(pn, { elevated: !0, outlined: !0, children: /* @__PURE__ */ r.jsxs(
            _,
            {
              container: !0,
              rowSpacing: 2,
              columnSpacing: 0,
              p: 2,
              sx: { width: "100%", m: 0, "& > .MuiGrid-item": { minWidth: 0 } },
              children: [
                /* @__PURE__ */ r.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsxs(je, { name: "name", textLabel: "Name", required: !0, children: [
                  /* @__PURE__ */ r.jsx(
                    De,
                    {
                      id: "name",
                      name: "concept_set_name",
                      type: "text",
                      size: "medium",
                      value: S.concept_set_name,
                      disabled: !!l,
                      placeholder: "Enter name",
                      onChange: (A) => {
                        D(""), ue(A);
                      },
                      fullWidth: !0
                    }
                  ),
                  y && /* @__PURE__ */ r.jsx(xe, { color: "error.main", variant: "caption", children: y })
                ] }) }),
                /* @__PURE__ */ r.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(je, { name: "description", textLabel: "Description", required: !0, children: /* @__PURE__ */ r.jsx(
                  De,
                  {
                    id: "description",
                    name: "text",
                    type: "text",
                    size: "medium",
                    value: S.text,
                    placeholder: "Enter description (prompt for generation).",
                    onChange: ue,
                    fullWidth: !0,
                    multiline: !0,
                    minRows: 6,
                    maxRows: 20
                  }
                ) }) }),
                /* @__PURE__ */ r.jsx(_, { item: !0, xs: 6, children: /* @__PURE__ */ r.jsx(je, { name: "domain", textLabel: "Domain", children: /* @__PURE__ */ r.jsx(
                  Ht,
                  {
                    id: "domain",
                    name: "domain",
                    options: ((u = R == null ? void 0 : R.domains) == null ? void 0 : u.filter(
                      (A) => {
                        var I;
                        return !((I = S.domain) != null && I.some(
                          (H) => H.value === A.value
                        ));
                      }
                    )) || [],
                    value: S.domain,
                    multiple: !0,
                    placeholder: (v = S.domain) != null && v.length ? "" : "Any",
                    onChange: (A, I) => {
                      C("domain", I);
                    },
                    fullWidth: !0,
                    isOptionEqualToValue: (A, I) => A.value === I,
                    getOptionLabel: Qt
                  }
                ) }) }),
                /* @__PURE__ */ r.jsx(_, { item: !0, xs: 6, sx: { pl: 2 }, children: /* @__PURE__ */ r.jsx(je, { name: "standard_concept", textLabel: "Standard Concept", children: /* @__PURE__ */ r.jsx(
                  Ht,
                  {
                    id: "standard_concept",
                    name: "standard_concept",
                    options: ((X = R == null ? void 0 : R.standard_concepts) == null ? void 0 : X.filter(
                      (A) => {
                        var I;
                        return !((I = S.standard_concept) != null && I.some(
                          (H) => H.value === A.value
                        ));
                      }
                    )) || [],
                    value: S.standard_concept,
                    placeholder: (q = S.standard_concept) != null && q.length ? "" : "Any",
                    multiple: !0,
                    onChange: (A, I) => {
                      C("standard_concept", I);
                    },
                    fullWidth: !0,
                    isOptionEqualToValue: (A, I) => A.value === I,
                    getOptionLabel: Qt
                  }
                ) }) }),
                /* @__PURE__ */ r.jsx(_, { item: !0, xs: 6, children: /* @__PURE__ */ r.jsx(je, { name: "vocabulary", textLabel: "Vocabulary", children: /* @__PURE__ */ r.jsx(
                  Ht,
                  {
                    id: "vocabulary",
                    name: "vocabulary",
                    options: ((ie = R == null ? void 0 : R.vocabularies) == null ? void 0 : ie.filter(
                      (A) => {
                        var I;
                        return !((I = S.vocabulary) != null && I.some(
                          (H) => H.value === A.value
                        ));
                      }
                    )) || [],
                    value: S.vocabulary,
                    multiple: !0,
                    placeholder: (fe = S.vocabulary) != null && fe.length ? "" : "Any",
                    onChange: (A, I) => {
                      C("vocabulary", I);
                    },
                    fullWidth: !0,
                    isOptionEqualToValue: (A, I) => A.value === I,
                    getOptionLabel: Qt
                  }
                ) }) }),
                /* @__PURE__ */ r.jsx(_, { item: !0, xs: 6, sx: { pl: 2 }, children: /* @__PURE__ */ r.jsx(je, { name: "search_precision", textLabel: "Search Precision", children: /* @__PURE__ */ r.jsx(
                  Is,
                  {
                    value: S.search_precision,
                    onChange: (A) => C("search_precision", A),
                    disabled: E
                  }
                ) }) }),
                /* @__PURE__ */ r.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(di, { children: /* @__PURE__ */ r.jsxs(ui, { htmlFor: "suggestion", children: [
                  /* @__PURE__ */ r.jsx(
                    ur,
                    {
                      id: "suggestion",
                      checked: S.suggestion,
                      onChange: (A) => $((I) => ({
                        ...I,
                        suggestion: A.target.checked
                      })),
                      disabled: E,
                      size: "small"
                    }
                  ),
                  "Suggest from external publications"
                ] }) }) }),
                /* @__PURE__ */ r.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsxs(fr, { children: [
                  /* @__PURE__ */ r.jsx(
                    ae,
                    {
                      variant: "outlined",
                      disabled: E,
                      onClick: s,
                      startIcon: /* @__PURE__ */ r.jsx(se, { iconName: "deactivate" }),
                      children: "Cancel"
                    }
                  ),
                  /* @__PURE__ */ r.jsx(
                    ae,
                    {
                      disabled: E || Ot(S.concept_set_name) || Ot(S.text),
                      onClick: oe,
                      variant: "contained",
                      color: "success",
                      startIcon: E ? /* @__PURE__ */ r.jsx(Ie, { size: 16 }) : /* @__PURE__ */ r.jsx(se, { iconName: "stars" }),
                      children: l ? "Regenerate" : "Generate"
                    }
                  )
                ] }) })
              ]
            }
          ) }),
          /* @__PURE__ */ r.jsxs(
            vs,
            {
              open: L,
              onClose: Q,
              maxWidth: "sm",
              fullWidth: !0,
              children: [
                /* @__PURE__ */ r.jsx(_s, { children: "Confirm duplicate concept-set handling:" }),
                /* @__PURE__ */ r.jsxs(Os, { children: [
                  /* @__PURE__ */ r.jsx(xe, { variant: "body2", color: "text.secondary", sx: { mb: 1.5 }, children: "In case AI generates concept sets that already exist in current Workspace or Study, would you like to" }),
                  /* @__PURE__ */ r.jsxs(Ce, { display: "flex", flexDirection: "column", rowGap: 1, children: [
                    /* @__PURE__ */ r.jsxs(Ce, { display: "flex", alignItems: "center", columnGap: 0.5, children: [
                      /* @__PURE__ */ r.jsx(
                        bt,
                        {
                          checked: g === "NEW_VERSION",
                          onChange: () => O("NEW_VERSION"),
                          name: "generate-conflict-resolution-dialog",
                          size: "small"
                        }
                      ),
                      /* @__PURE__ */ r.jsx(xe, { variant: "subtitle2", children: "OVERWRITE existing Concept Set(s) where possible (recommended)" }),
                      /* @__PURE__ */ r.jsx(pt, { text: ai, children: /* @__PURE__ */ r.jsx(
                        se,
                        {
                          iconName: "info",
                          sx: { fontSize: 14, color: "text.secondary" }
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ r.jsxs(Ce, { display: "flex", alignItems: "center", columnGap: 0.5, children: [
                      /* @__PURE__ */ r.jsx(
                        bt,
                        {
                          checked: g === "NEW_OBJECT",
                          onChange: () => O("NEW_OBJECT"),
                          name: "generate-conflict-resolution-dialog",
                          size: "small"
                        }
                      ),
                      /* @__PURE__ */ r.jsx(xe, { variant: "subtitle2", children: "Create NEW Concept Set(s)" }),
                      /* @__PURE__ */ r.jsx(pt, { text: ii, children: /* @__PURE__ */ r.jsx(
                        se,
                        {
                          iconName: "info",
                          sx: { fontSize: 14, color: "text.secondary" }
                        }
                      ) })
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ r.jsxs(Ns, { children: [
                  /* @__PURE__ */ r.jsx(
                    ae,
                    {
                      variant: "outlined",
                      color: "darkGrey",
                      disabled: E,
                      onClick: Q,
                      children: "Cancel"
                    }
                  ),
                  /* @__PURE__ */ r.jsx(
                    ae,
                    {
                      variant: "contained",
                      color: "success",
                      disabled: E,
                      onClick: () => {
                        ce();
                      },
                      children: l ? "Regenerate" : "Generate"
                    }
                  )
                ] })
              ]
            }
          )
        ]
      }
    );
  }
), pi = ({
  viewMode: e = !1
  //need it for now
}) => {
  const t = Bt(), n = xr(), { enqueueSnackbar: s } = st(), a = Te(
    Et
  ), { openModal: o, closeModal: i } = Te(qe), [l, p] = ee(), [c, d] = ee(!1), m = yr(
    (g) => g.user
  ), E = k(() => {
    var g;
    return (g = m.data.moduleIds) == null ? void 0 : g.includes("ai");
  }, [m]), h = k(() => a == null ? void 0 : a.config, []), y = k(() => xn(h.typeContainer, h.parentId), [h.typeContainer, h.parentId]), D = k(() => rt(h.typeContainer, h.parentId), [h.typeContainer, h.parentId]), L = () => {
    n(vo(h.typeContainer, h.parentId));
  }, b = () => {
    o(
      () => /* @__PURE__ */ r.jsx(
        Tn,
        {
          parentId: h.parentId,
          typeContainer: h.typeContainer,
          createMethod: D,
          onCancel: i,
          afterCreate: (g) => {
            s({
              message: "Concept set created successfully",
              variant: "success"
            }), t(g.id), i(), L();
          }
        }
      ),
      "Add concept set",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: i
      }
    );
  }, M = () => {
    o(
      () => /* @__PURE__ */ r.jsx(
        Gr,
        {
          parentId: h.parentId,
          typeContainer: h.typeContainer,
          createMethod: D,
          onCancel: i,
          onGenerateStart: () => {
            i(), s({
              message: "Concept set generate in progress...",
              variant: "success"
            }), d(!0);
          },
          onGenerateError: () => {
            d(!1);
          },
          afterCreate: (g) => {
            t(`${g.id}`, {
              state: { aiGenerateRequested: !0 }
            }), L();
          }
        }
      ),
      "Generate concept set",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: i
      }
    );
  }, B = () => {
    o(
      () => /* @__PURE__ */ r.jsx(
        hn,
        {
          name: "concept-sets",
          currentContainer: h.typeContainer,
          parentId: h.parentId,
          onChange: async () => {
            p(qs()), i(), L();
          },
          createListMethods: Pt,
          cols: Ft,
          createListFiltersMethod: Dt,
          createMethodCreate: rt,
          subModules: a.subModules,
          isSelect: !0,
          hideConflictResolutionMethod: !0,
          hideConflictResolutionControls: !0,
          atlasEntity: [Ct.CS],
          successMessage: "Concept set(s) successfully imported.",
          manualImport: !0,
          manualImportComponent: /* @__PURE__ */ r.jsx(
            yn,
            {
              typeContainer: h.typeContainer,
              parentId: h.parentId,
              createMethod: y,
              onChange: (g) => {
                t(g.id), i(), L();
              },
              onClose: i
            }
          )
        }
      ),
      "Import concept set",
      {
        onClose: i,
        closeOnClickOutside: !0
      }
    );
  };
  return c ? /* @__PURE__ */ r.jsx(Pe, { background: "/images/back.png", children: /* @__PURE__ */ r.jsx(pr, {}) }) : /* @__PURE__ */ r.jsx(
    hr,
    {
      reloadId: l,
      isImport: !0,
      onImport: B,
      onCreate: b,
      onGenerate: E && M,
      moduleConfig: a,
      viewMode: e,
      listConfig: {
        rowId: "id",
        loadingMessage: "Loading concept sets...",
        addButtonTitle: "Add concept set",
        tableTitle: "Concept sets",
        moduleDescription: "Concept set is an expression representing a list of vocabulary concepts/codes to define a drug, condition, measurement or other objects that can be used as a reusable component in cohorts and analyses.",
        importButtonTitle: "Import",
        listInitialSort: { id: "modified.timestamp", desc: !0 },
        createCrudMethod: Pt,
        createFiltersPanel: Dt,
        createSortingMethod: Zo,
        getCols: ta,
        metadataFilter: "&filter.metadata.subject=CONCEPT_SET",
        extendedSearchEnabled: !1
      },
      variant: "description",
      allowDelete: !0
    }
  );
}, Et = xs(null), mi = (e) => {
  const { path: t, title: n, name: s, rootSettings: a, initStorage: o, viewMode: i } = e, [l, p] = ee(a), [c, d] = ee(!0);
  return J(() => {
    a || p({
      rootPath: t,
      rootTitle: n
    }), d(!1);
  }, []), c ? /* @__PURE__ */ r.jsx(Pe, { children: /* @__PURE__ */ r.jsx(Ie, { size: 32 }) }) : /* @__PURE__ */ r.jsx(Et.Provider, { value: { ...e, rootSettings: l }, children: /* @__PURE__ */ r.jsxs(gr, { children: [
    /* @__PURE__ */ r.jsx(ye, { path: ":id/*", element: /* @__PURE__ */ r.jsx(Yr, {}) }),
    /* @__PURE__ */ r.jsx(ye, { index: !0, element: /* @__PURE__ */ r.jsx(pi, { viewMode: i }) })
  ] }) });
}, fi = (e, t) => ({
  get: (n) => Wt(n),
  delete: (n) => br(n),
  update: (n, s) => {
    switch (e) {
      case j.STUDY:
        return Bo(n, s, t);
      case j.WORKSPACE:
        return $o(n, s);
      case j.LIBRARY:
        return Go(s, {
          name: n.name,
          description: n.description
        });
    }
  },
  copy: (n, s, a = te.COPY) => {
    switch (e) {
      case j.STUDY:
        return Ar(t, n, s, a);
      case j.WORKSPACE:
        return Rr(n, s, a);
    }
  }
}), Ci = (e, t = 0, n = 0, s, a, o, i, l, p, c, d) => {
  var y;
  let m = [
    {
      id: "expression",
      title: /* @__PURE__ */ r.jsx(
        Re,
        {
          title: "Expression",
          count: ((y = o.expression) == null ? void 0 : y.toLocaleString()) || 0,
          status: P.SUCCESS
        }
      ),
      value: "",
      end: !0
    },
    {
      id: "included-concepts",
      title: /* @__PURE__ */ r.jsx(
        kt,
        {
          count: t,
          isLoading: l,
          items: a,
          getCount: s,
          versionId: e,
          type: ve.INCLUDED_CONCEPTS
        }
      ),
      value: "included"
    },
    {
      id: "included-source-codes",
      title: /* @__PURE__ */ r.jsx(
        kt,
        {
          count: n,
          isLoading: i,
          message: "Included source codes",
          items: a,
          getCount: s,
          versionId: e,
          type: ve.INCLUDED_SOURCE_CODES
        }
      ),
      value: "source-codes"
    }
  ];
  m.push({
    id: "versions",
    align: "right",
    iconOnly: !0,
    iconName: "reload",
    title: /* @__PURE__ */ r.jsx(
      Re,
      {
        title: "Versions",
        count: o.versions || 0,
        status: P.SUCCESS
      }
    ),
    value: "versions"
  }), m.push({
    id: "meta-attributes",
    align: "right",
    iconOnly: !0,
    iconName: "bookmark",
    title: /* @__PURE__ */ r.jsx(
      Re,
      {
        title: "Metadata",
        count: o.metadata || 0,
        status: P.SUCCESS
      }
    ),
    value: "meta-attributes"
  }), o.metadataAi && m.push({
    id: "ai-meta-attributes",
    align: "right",
    iconOnly: !0,
    iconName: "stars",
    title: /* @__PURE__ */ r.jsx(
      Re,
      {
        title: "Generative AI",
        count: o.metadataAi || 0,
        status: P.SUCCESS,
        dense: !0
      }
    ),
    value: "ai-meta-attributes"
  }), c !== j.LIBRARY && Number(o.usedIn || 0) > 0 && m.push({
    id: "usage",
    align: "right",
    iconOnly: !0,
    iconName: "users",
    title: /* @__PURE__ */ r.jsx(
      Re,
      {
        title: "Used In",
        count: o.usedIn || 0,
        status: P.SUCCESS,
        dense: !0
      }
    ),
    value: "usage"
  }), c === j.LIBRARY && m.push({
    id: "statistics",
    align: "right",
    iconOnly: !0,
    iconName: "chart",
    title: /* @__PURE__ */ r.jsx(
      Re,
      {
        title: "Utilization Statistics",
        count: o.usedIn || 0,
        status: P.SUCCESS,
        dense: !0
      }
    ),
    value: "statistics"
  });
  const E = Number(o.suggestions || 0);
  return !p && (E > 0 || d === Ze.IN_PROGRESS) && m.push({
    id: "ai-suggested",
    align: "right",
    iconOnly: !0,
    iconName: "aiStars",
    title: /* @__PURE__ */ r.jsx(
      Re,
      {
        title: "External Publications (AI)",
        count: E,
        status: d === Ze.IN_PROGRESS ? P.IN_PROGRESS : P.SUCCESS,
        dense: !0
      }
    ),
    value: "ai-suggested"
  }), m;
}, hi = "New Concept set", Ei = {
  entityBreadcrumbs: (e, t, n, s) => Hs(
    hi,
    e,
    t,
    n,
    s
  ),
  messages: {
    confirmDeleteMessage: "Are you sure you want to delete this concept set?"
  },
  apiMethodsVersioning: {
    getList: Wo,
    getCurrent: Lr
  }
}, gi = {
  conceptSet: null,
  conceptSetStatus: P.INITIAL,
  conceptSetError: null,
  countIncludedConcepts: 0,
  countIncludedSourceCodes: 0,
  loadingCountsSourceCodes: !1,
  loadingCountsIncludedConcepts: !1,
  summary: {},
  aiAttrbutes: [],
  aiGenerate: !1,
  aiJobId: null,
  aiStatus: null,
  aiOutput: null,
  aiValues: null,
  aiCompleteTimestamp: null,
  aiCompleteGeneration: !0,
  aiGenerationPending: !1,
  isAiCohort: !1
}, Si = (e, t) => Cn(e, (n) => {
  switch (t.type) {
    case "SET_CONCEPSET":
      n.conceptSetStatus = P.SUCCESS, n.conceptSet = t.payload;
      break;
    case "SAVE_CONCEPT_SET":
      n.conceptSetStatus = P.IN_PROGRESS;
      break;
    case "SAVE_CONCEPT_SET_DONE":
      n.conceptSetStatus = P.SUCCESS;
      break;
    case "SAVE_CONCEPT_SET_ERROR":
      n.conceptSetStatus = P.ERROR;
      break;
    case "UPDATE_CONCEPSET":
      n.conceptSet && (n.conceptSet[t.payload.prop] = t.payload.value);
      break;
    case "ADD_CONCEPTSET_ITEMS":
      if (n.conceptSet) {
        const s = t.payload;
        n.conceptSet.items = {
          ...n.conceptSet.items,
          ...s
        };
      }
      break;
    case "SET_AI_ATTRIBUTES":
      if (n.aiValues = t.payload.aiValues, n.isAiCohort = t.payload.isAiCohort, t.payload.terminalAiStatus) {
        n.aiGenerate = !1, n.aiGenerationPending = !1;
        break;
      }
      t.payload.aiGenerate && (n.aiGenerationPending = !1), n.aiGenerate = t.payload.aiGenerate || n.aiGenerationPending;
      break;
    case "START_GENERATION":
      n.aiGenerate = !0, n.aiGenerationPending = !0;
      break;
    case "SET_AI_RESULTS":
      n.aiStatus = t.payload.aiStatus, n.aiOutput = t.payload.aiOutput, n.aiCompleteTimestamp = t.payload.aiCompleteTimestamp;
      break;
    case "FINISH_GENERATION":
      n.aiCompleteGeneration = !0, n.aiJobId = null;
      break;
    case "SET_COUNT_REQUEST":
      t.payload == ve.INCLUDED_CONCEPTS ? n.loadingCountsIncludedConcepts = !0 : n.loadingCountsSourceCodes = !0;
      break;
    case "SET_COUNT_REQUEST_DONE":
      if (t.payload.reset) {
        n.countIncludedConcepts = 0, n.countIncludedSourceCodes = 0, n.loadingCountsIncludedConcepts = !1, n.loadingCountsSourceCodes = !1;
        break;
      }
      t.payload.typeOfIncluded == ve.INCLUDED_CONCEPTS ? (n.loadingCountsIncludedConcepts = !1, n.countIncludedConcepts = t.payload.count) : (n.loadingCountsSourceCodes = !1, n.countIncludedSourceCodes = t.payload.count);
      break;
    case "GET_SUMMARY":
      n.summary = t.payload;
      break;
  }
}), xi = (e, t, n) => {
  const s = Ls(e, t, n), [a, o] = un(
    Si,
    gi
  ), i = V(async () => {
    try {
      const g = await zo(t);
      o({
        type: "GET_SUMMARY",
        payload: g
      });
    } catch {
    }
  }, [t]), l = V((g) => {
    o({
      type: "SET_CONCEPSET",
      payload: {
        ...g,
        items: Ia(g.items)
      }
    });
  }, []), p = (g) => {
    o({
      type: "UPDATE_CONCEPTSET_ITEMS",
      payload: g
    });
  }, c = (g) => {
    o({
      type: "ADD_CONCEPTSET_ITEMS",
      payload: g
    });
  }, d = V(
    (g, O) => {
      o({
        type: "UPDATE_CONCEPSET",
        payload: {
          prop: g,
          value: O
        }
      });
    },
    [a.conceptSet]
  ), m = V(
    (g, O) => {
      const T = g || (s == null ? void 0 : s.entity), N = O || (a == null ? void 0 : a.conceptSet);
      if (!(T != null && T.items) || !(N != null && N.items))
        return [];
      const K = {
        items: Ge(T == null ? void 0 : T.items)
      }, z = {
        items: Ge(N == null ? void 0 : N.items)
      }, ne = zt(K, z);
      return Br(ne, z.items);
    },
    [s.entity, a.conceptSet]
  ), E = async (g) => {
    var z;
    const O = await wt(
      "filter.metadata.value.subject.id",
      t
    ), T = O.content.find(Zt), N = (z = O.content.find(Js)) == null ? void 0 : z.value, K = (T == null ? void 0 : T.value) === "Yes" && ["IN_PROGRESS", "QUEUED"].includes(N);
    o({
      type: "SET_AI_ATTRIBUTES",
      payload: {
        aiValues: O.content,
        // Terminal AI events are authoritative even if metadata is briefly stale.
        aiGenerate: g ? !1 : K,
        terminalAiStatus: g,
        isAiCohort: (T == null ? void 0 : T.value) === "Yes"
      }
    });
  }, h = V(() => {
    o({
      type: "START_GENERATION"
      /* START_GENERATION */
    });
  }, []), y = V(
    async (g) => {
      var O, T;
      if ((T = Object.values(((O = a.conceptSet) == null ? void 0 : O.items) || {})) != null && T.length) {
        o({
          type: "SET_COUNT_REQUEST",
          payload: g
        });
        try {
          const N = g == ve.INCLUDED_CONCEPTS ? await jr(t, {
            delta: m()
          }) : await wr(t, {
            delta: m()
          });
          o({
            type: "SET_COUNT_REQUEST_DONE",
            payload: {
              typeOfIncluded: g,
              count: N
            }
          });
        } catch {
        }
      } else
        o({
          type: "SET_COUNT_REQUEST_DONE",
          payload: {
            reset: !0
          }
        });
    },
    [s.entity, a.conceptSet]
  ), D = async (g) => {
    await s.getEntity(), await E(g);
  }, L = V(
    (g, O) => {
      var T, N;
      if ((N = Object.values(((T = a.conceptSet) == null ? void 0 : T.items) || {})) != null && N.length)
        try {
          return Pr(O, g, t, {
            delta: m()
          });
        } catch (K) {
          console.error("Error fetching included concepts:", K);
        }
      else
        return o({
          type: "SET_COUNT_REQUEST_DONE",
          payload: {
            reset: !0
          }
        }), Promise.resolve(null);
    },
    [s.entity, a.conceptSet]
  ), b = V(
    (g, O) => {
      const T = m();
      try {
        return Dr(O, g, t, {
          delta: T
        });
      } catch (N) {
        console.error("Error fetching included concepts filters:", N);
      }
    },
    [s.entity, a.conceptSet]
  ), M = V(
    async (g) => {
      o({
        type: "SAVE_CONCEPT_SET"
        /* SAVE_CONCEPT_SET */
      });
      const O = {
        ...a.conceptSet,
        name: g.name,
        description: g.description,
        delta: m()
      };
      try {
        await s.updateEntity(O), await i();
      } catch {
        o({
          type: "SAVE_CONCEPT_SET_ERROR"
          /* SAVE_CONCEPT_SET_ERROR */
        });
      }
    },
    [a.conceptSet]
  ), B = k(() => !!(s.status !== P.SUCCESS || a.conceptSetStatus !== P.SUCCESS || m().length === 0 && jt(s.entity.name, a.conceptSet.name) && jt(s.entity.description, a.conceptSet.description)), [
    s.status,
    a.conceptSetStatus,
    s.entity,
    a.conceptSet
  ]);
  return J(() => {
    s.status === P.SUCCESS && (async () => (await E(), await i(), l(s.draft)))();
  }, [s.draft]), {
    ...a,
    ...s,
    updateDesign: d,
    submitEntity: M,
    getCountIncluded: y,
    setDesign: l,
    getIncludedConcepts: L,
    getIncludedConceptsFilters: b,
    addConceptSetItemsBulk: c,
    isEqual: B,
    getCountsSummary: i,
    refetchEntity: D,
    startGeneration: h,
    updateConceptSetItemsBulk: p,
    getItemsDelta: m,
    isLoadingAi: a.aiGenerate && (a.aiStatus === "PROCESSING" || !a.aiCompleteGeneration)
  };
}, lr = ({}) => {
  const { id: e } = Sr(), { status: t, state: n } = Ms(Qo, e), s = Ks(n);
  return /* @__PURE__ */ r.jsx(po, { board: s == null ? void 0 : s.board, status: t, list: s == null ? void 0 : s.list });
}, yi = (e) => {
  const { id: t, typeContainer: n, parentId: s } = e, a = Bt(), { closeModal: o } = Te(qe), i = Te(
    Et
  );
  return /* @__PURE__ */ r.jsx(
    hr,
    {
      isImport: !1,
      isEnableMetadata: !0,
      moduleConfig: i,
      uniqName: "Usage",
      onRowClick: (l) => {
        var c, d, m;
        const p = ea(
          l.original.id,
          l.original.type,
          l.original.supertype,
          n,
          s
        );
        if ((d = (c = i == null ? void 0 : i.config) == null ? void 0 : c.onCancel) == null || d.call(c), o(), window.dispatchEvent(new Event("prometheus:close-modal")), (m = i == null ? void 0 : i.config) != null && m.saveOnlyActions) {
          window.location.assign(p);
          return;
        }
        a(p);
      },
      listConfig: {
        rowId: "id",
        loadingMessage: "Loading Used In references...",
        tableTitle: "Used In",
        moduleDescription: "",
        listInitialSort: { id: "name", desc: !1 },
        addButtonTitle: null,
        createCrudMethod: () => ({
          fetch: (l, p, c, d) => Nr(t, {
            pageNumber: l,
            pageSize: p,
            sortBy: c,
            query: d
          })
        }),
        createFiltersPanel: () => ({
          getFilters: (l) => ko(l, t),
          formatFilters: Qs
        }),
        createSortingMethod: () => () => Do(t),
        cols: ra
      },
      variant: "no-header",
      dense: !0
    }
  );
}, Yr = ({
  entityId: e,
  onEntityReady: t,
  onEntitySaved: n,
  saveOnlyActions: s = !1
}) => {
  var Gn;
  const { id: a } = Sr(), o = e || a, i = xr(), l = Bt(), p = Er(), [c, d] = ee(null), [m, E] = ee(""), [h, y] = ee(0), [D, L] = ee(!1), [b] = yo(), M = !!((Gn = p.state) != null && Gn.aiGenerateRequested), { rootSettings: B, path: g, title: O, config: T, subModules: N } = Te(
    Et
  ), { showDialog: K, hideDialog: z } = Te(Us), { enqueueSnackbar: ne } = st(), { openModal: G, closeModal: S } = Te(qe), { rootPath: $, rootTitle: Y } = B, { parentId: R, parentTitle: de, typeContainer: W } = T, { messages: he, entityBreadcrumbs: ue, apiMethodsVersioning: C } = Ei, w = k(() => fi(W, R), [R]), F = k(() => rt(T.typeContainer, T.parentId), [T.typeContainer, T.parentId]), Q = yr(
    (f) => {
      var Z;
      return ((Z = f.user.data.moduleIds) == null ? void 0 : Z.includes("ai")) ?? !1;
    }
  ), { start: ce, stop: oe, status: u } = ks(), {
    entity: v,
    aiGenerate: X,
    addConceptSetItemsBulk: q,
    submitEntity: ie,
    refetchEntity: fe,
    startGeneration: A,
    aiValues: I,
    actions: H,
    updateEntity: pe,
    isVersionMode: Ee,
    status: me,
    error: Je,
    conceptSet: x,
    version: Me,
    conceptSetStatus: _e,
    setVersionEntity: qr,
    revertEntity: Hr,
    deleteEntity: Jr,
    copyEntity: Kr,
    countIncludedConcepts: On,
    countIncludedSourceCodes: Nn,
    loadingCountsSourceCodes: bn,
    loadingCountsIncludedConcepts: Rn,
    getIncludedConcepts: An,
    getIncludedConceptsFilters: jn,
    getCountIncluded: Qr,
    isAiCohort: Xr,
    clearConceptSetLogItems: Zr,
    isEqual: es,
    summary: ot,
    getCountsSummary: Ke,
    updateDesign: Gt,
    getItemsDelta: wn
  } = xi(w, o, "Concept set"), Pn = mo(), Dn = k(() => W === j.LIBRARY ? Pn : !!(H != null && H["update.metadata"] || H != null && H[To.UPDATE]), [H, Pn, W]);
  J(() => {
    M && (A(), l(
      {
        pathname: p.pathname,
        search: p.search,
        hash: p.hash
      },
      { replace: !0, state: null }
    ));
  }, [
    M,
    p.hash,
    p.pathname,
    p.search,
    l,
    A
  ]);
  const at = k(() => {
    const Z = (I == null ? void 0 : I.some(Zt)) ? 1 : 0, Ne = (I == null ? void 0 : I.filter(
      (be) => Xs(be) && !Zt(be)
    ).length) || 0;
    return {
      ...ot,
      metadata: (ot.metadata || 0) + Z,
      "metadata-ai": Math.max(
        (ot["metadata-ai"] || 0) - Z,
        Ne
      )
    };
  }, [I, ot]), ts = () => {
    G(
      () => /* @__PURE__ */ r.jsx(
        go,
        {
          propId: "conceptSetId",
          onClose: S,
          item: v,
          inviteMethod: Vo
        }
      ),
      "Publish concept set",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: S
      }
    );
  }, ns = (f) => {
    G(
      () => /* @__PURE__ */ r.jsx(
        N.cohort,
        {
          type: "component",
          name: "create-cohort-from-concept-set",
          subModules: N,
          config: {
            onCancel: S,
            entity: v,
            parentId: R,
            typeContainer: W
          }
        }
      ),
      f.name,
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: S
      }
    );
  }, rs = () => {
    G(
      () => /* @__PURE__ */ r.jsx(
        Cr,
        {
          id: v.id,
          name: x.name,
          parentId: R,
          currentContainer: W,
          subModules: N,
          jsonImportTabName: "Concept Set Items",
          createCopyMethod: $r,
          typeEntity: "concept-sets",
          entityAtlas: Ct.CS,
          defaultResolution: te.CREATE_NEW_OBJECT,
          hideConflictResolutionControls: !0,
          validateName: async (f) => f.typeContainer === j.WORKSPACE ? ze(
            j.WORKSPACE,
            f.name
          ) : f.typeContainer === j.STUDY ? f.studyId ? ze(
            j.STUDY,
            f.name,
            String(f.studyId)
          ) : {
            isValid: !1,
            message: "Study is required."
          } : { isValid: !0 },
          onChange: () => {
            S();
          },
          exportJson: /* @__PURE__ */ r.jsx(zr, { id: x.id, title: x.name }),
          customAction: /* @__PURE__ */ r.jsx(
            "a",
            {
              href: `/api/conceptset/${v.id}/included/csv-zip`,
              target: "_blank",
              children: /* @__PURE__ */ r.jsx(
                ae,
                {
                  variant: "contained",
                  color: "success",
                  size: "small",
                  startIcon: /* @__PURE__ */ r.jsx(se, { iconName: "export" }),
                  children: "Export to CSV"
                }
              )
            }
          )
        }
      ),
      "Export concept set",
      {
        closeOnClickOutside: !0,
        onClose: S
      }
    );
  }, ss = !!(H["update.name"] || H["update.description"]), Ue = !(H != null && H[Io.UPDATE]), Yt = k(() => {
    var f;
    return Ci(
      x == null ? void 0 : x.versionId,
      On,
      Nn,
      Qr,
      x == null ? void 0 : x.items,
      {
        expression: (f = Object.values((x == null ? void 0 : x.items) || {})) == null ? void 0 : f.length,
        versions: at.versions,
        metadata: at.metadata,
        metadataAi: at["metadata-ai"],
        usedIn: h,
        suggestions: at.suggestions
      },
      bn,
      Rn,
      Ue,
      W,
      c
    );
  }, [
    o,
    g,
    b,
    bn,
    Rn,
    On,
    Nn,
    x == null ? void 0 : x.versionId,
    W,
    x == null ? void 0 : x.items,
    at,
    h,
    c
  ]), gt = k(
    () => [
      "included",
      "source-codes",
      "versions",
      "meta-attributes",
      "ai-meta-attributes",
      "ai-suggested",
      "usage",
      "statistics"
    ],
    []
  ), Qe = k(
    () => (p.pathname.split("/modal")[0] || p.pathname).replace(
      /\/+$/,
      ""
    ) || "/",
    [p.pathname]
  ), Oe = k(() => s ? gt.find(
    (f) => Qe.endsWith(`/${f}`)
  ) || "expression" : "", [Qe, gt, s]), Xe = k(() => {
    if (!s)
      return "";
    const f = gt.find(
      (Z) => Qe.endsWith(`/${Z}`)
    );
    return f ? Qe.slice(0, -`/${f}`.length) || "/" : Qe;
  }, [Qe, gt, s]), it = k(
    () => Xe.replace(/^\/+/, ""),
    [Xe]
  ), os = k(() => {
    if (!s)
      return Yt;
    const f = Xe || "/";
    return Yt.map((Z) => {
      const Ne = String(Z.value || "");
      return Ne ? Ne.startsWith("/") ? Z : {
        ...Z,
        value: f === "/" ? `/${Ne}` : `${f}/${Ne}`
      } : {
        ...Z,
        value: f
      };
    });
  }, [Xe, s, Yt]), St = V(() => {
    if (s) {
      l(`${Xe}${p.search || ""}`);
      return;
    }
    l(`/${g}/${o}`);
  }, [Xe, o, p.search, l, g, s]), xt = (v == null ? void 0 : v.id) ?? o, as = s ? it : `${g}/${xt}`, is = s ? `${it}/included` : `${g}/${xt}/included`, cs = s ? `${it}/source-codes` : `${g}/${xt}/source-codes`, ls = s ? `${it}/ai-suggested` : `${g}/${xt}/ai-suggested`, Ln = k(() => wn(), [wn]), ds = k(
    () => ({
      concepts: x == null ? void 0 : x.items,
      onChange: q,
      onFinish: () => {
        St();
      },
      viewMode: Ue,
      parentId: R,
      typeContainer: W,
      conceptSetId: o,
      suggestionStatus: c,
      delta: Ln
    }),
    [
      x == null ? void 0 : x.items,
      q,
      St,
      Ue,
      R,
      W,
      c,
      Ln
    ]
  ), us = () => {
    K(So, {
      onSubmit: async () => {
        try {
          await Jr(), l(`/${g}`);
        } catch {
        }
      },
      onClose: z,
      text: he.confirmDeleteMessage,
      confirmButtonText: "DELETE"
    });
  }, ps = fo(
    v == null ? void 0 : v.id,
    W === j.LIBRARY,
    g
  ), ms = V(() => {
    try {
      i(
        _o("conceptSets", {
          ...Ee ? { ...Me, versionId: Me.revertVersionId } : v,
          parentId: R,
          typeContainer: W
        })
      ), ne({
        message: `Concept set ${v.name} has been added to comparison`,
        variant: "success"
      });
    } catch (f) {
      console.error(f), ne({
        message: "Oops! Something went wrong",
        variant: "error"
      });
    }
  }, [ot, v, Ee, Me, R]), fs = V(
    async (f) => {
      if ((f == null ? void 0 : f.name) !== (v == null ? void 0 : v.name) && W !== j.LIBRARY) {
        const be = await ze(
          W,
          f.name,
          R,
          v == null ? void 0 : v.id
        );
        if (!be.isValid) {
          E(be.message || "");
          return;
        }
      }
      E(""), L(!0), await ie(f);
    },
    [v == null ? void 0 : v.id, v == null ? void 0 : v.name, R, ie, W]
  );
  J(() => {
    if (!D)
      return;
    if (_e === P.ERROR) {
      L(!1);
      return;
    }
    if (_e !== P.SUCCESS || me !== P.SUCCESS)
      return;
    const f = v || x;
    f && (n == null || n({
      id: f == null ? void 0 : f.id,
      name: f == null ? void 0 : f.name,
      versionId: f == null ? void 0 : f.versionId,
      versionOrdinal: f == null ? void 0 : f.versionOrdinal,
      version: f == null ? void 0 : f.version,
      currentVersionId: (f == null ? void 0 : f.currentVersionId) ?? (f == null ? void 0 : f.versionId),
      currentVersionOrdinal: (f == null ? void 0 : f.currentVersionOrdinal) ?? (f == null ? void 0 : f.versionOrdinal) ?? (f == null ? void 0 : f.version)
    })), L(!1);
  }, [
    x,
    _e,
    v,
    D,
    n,
    me
  ]);
  const Cs = () => {
    var Z;
    const f = (Z = I == null ? void 0 : I.find(
      (Ne) => {
        var be;
        return ((be = Ne.attribute) == null ? void 0 : be.name) == "ai-prompt";
      }
    )) == null ? void 0 : Z.value;
    G(
      () => /* @__PURE__ */ r.jsx(
        Gr,
        {
          parentId: T.parentId,
          typeContainer: T.typeContainer,
          entity: v,
          prompt: f,
          attributes: I ?? void 0,
          createMethod: F,
          onCancel: S,
          onGenerateStart: () => {
            A(), S(), ne({
              message: "Concept set regenerate in progress...",
              variant: "success"
            });
          },
          onGenerateError: () => {
            fe();
          },
          afterCreate: async () => {
            await fe(), await Ke();
          }
        }
      ),
      "Regenerate Concept Set",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: S
      }
    );
  }, hs = W === j.LIBRARY && b.get("from") !== j.LIBRARY, Es = () => {
    G(
      () => /* @__PURE__ */ r.jsx(
        N.users,
        {
          type: "component",
          name: "share-entity",
          subModules: N,
          config: {
            ...T,
            entity: v,
            entityType: "Concept Set",
            onClose: S,
            onChange: S
          }
        }
      ),
      "Share Concept Set",
      {
        closeOnClickOutside: !0,
        onClose: S,
        width: "700px"
      }
    );
  }, gs = () => {
    G(
      () => /* @__PURE__ */ r.jsx(
        N.vocabulary,
        {
          type: "component",
          name: "ai-suggest-dialog",
          subModules: N,
          config: {
            entity: v,
            entityType: "Concept Set",
            onClose: () => {
              S();
            },
            onFinish: () => {
              Ss(), d(Ze.IN_PROGRESS), l("ai-suggested");
            },
            conceptSetId: o,
            suggestionStatus: c
          }
        }
      ),
      "Suggest from external publications",
      {
        closeOnClickOutside: !0,
        onClose: S,
        width: "700px"
      }
    );
  }, Ss = $s(
    () => tr(o).then((f) => d((f == null ? void 0 : f.status) || null)).catch(console.error),
    () => c === Ze.DONE || c === Ze.ERROR || c == null,
    1e4
  );
  J(() => {
    x != null && x.id && X && ce({
      subjectId: x == null ? void 0 : x.id
    });
  }, [X, x == null ? void 0 : x.id]), J(() => () => oe(), []), J(() => {
    let f;
    return ["DONE", "ERROR"].includes(u) && (f = setTimeout(() => {
      fe(u), oe();
    }, 3e3)), () => clearTimeout(f);
  }, [u]), J(() => {
    i(
      Oo(
        ue(o, v == null ? void 0 : v.name, {
          path: g,
          title: O,
          rootPath: $,
          rootTitle: Y,
          parentTitle: de,
          parentId: R
        })
      )
    );
  }, [g, v]), J(() => {
    o && tr(o).then((f) => d((f == null ? void 0 : f.status) || null)).catch(console.error);
  }, [o]), J(() => {
    c === Ze.DONE && Ke();
  }, [c]), J(() => {
    if (!o || o === "new" || W === j.LIBRARY) {
      y(0);
      return;
    }
    Nr(o, {
      pageNumber: 0,
      pageSize: 1,
      sortBy: {
        id: "name",
        desc: !1
      },
      query: ""
    }).then((f) => {
      const Z = Number(
        (f == null ? void 0 : f.totalElements) ?? (f == null ? void 0 : f.numberOfElements) ?? (Array.isArray(f == null ? void 0 : f.content) ? f.content.length : 0)
      );
      y(Number.isNaN(Z) ? 0 : Z);
    }).catch(() => y(0));
  }, [o, W]), J(() => {
    document.title = "Prometheus - " + Y + " - Concept sets";
  }, [Y]);
  const Mn = b.get("from") && b.get("from") === j.LIBRARY, qt = [P.INITIAL, P.IN_PROGRESS].includes(me) || [P.INITIAL].includes(_e) || X || M;
  if (J(() => {
    qt || t == null || t();
  }, [qt, t]), me === P.ERROR)
    return /* @__PURE__ */ r.jsx(Pe, { children: /* @__PURE__ */ r.jsx(Hn, { ...Je.response, path: g }) });
  if (qt) {
    const f = X || M;
    return /* @__PURE__ */ r.jsx(
      Pe,
      {
        background: f && "/images/back.png",
        children: f ? /* @__PURE__ */ r.jsx(pr, {}) : /* @__PURE__ */ r.jsx(Ie, { size: 62 })
      }
    );
  }
  if (!s && o !== "new" && !(v != null && v.id))
    return /* @__PURE__ */ r.jsx(Pe, { children: /* @__PURE__ */ r.jsx(
      Hn,
      {
        status: 404,
        statusText: "Not Found",
        message: "Concept set not found",
        data: null,
        path: g
      }
    ) });
  const Un = /* @__PURE__ */ r.jsx(Be, { children: /* @__PURE__ */ r.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
    N.vocabulary,
    {
      type: "component",
      name: "included-concepts",
      path: is,
      subModules: N,
      config: {
        concepts: [],
        methodIncluded: An,
        filtersIncluded: jn,
        onChange: q,
        conceptSetId: x == null ? void 0 : x.id,
        versionId: x == null ? void 0 : x.versionId,
        onFinish: St,
        viewMode: Ue,
        outlined: !0
      }
    }
  ) }) }), kn = /* @__PURE__ */ r.jsx(Be, { children: /* @__PURE__ */ r.jsx(_, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
    N.vocabulary,
    {
      type: "component",
      name: "included-concepts-source-codes",
      path: cs,
      subModules: N,
      config: {
        concepts: [],
        methodIncluded: An,
        filtersIncluded: jn,
        onChange: q,
        conceptSetId: x == null ? void 0 : x.id,
        versionId: x == null ? void 0 : x.versionId,
        onFinish: St,
        viewMode: Ue
      }
    }
  ) }) }), $n = /* @__PURE__ */ r.jsx(Be, { children: /* @__PURE__ */ r.jsx(
    Co,
    {
      data: x,
      path: s ? it : g,
      makeCopy: () => {
      },
      setPreviewEntity: qr,
      apiMethods: C,
      originVersionId: v.versionId
    }
  ) }), Bn = /* @__PURE__ */ r.jsx(
    Jn,
    {
      id: v.id,
      name: v.name,
      metadataSubject: Nt.CONCEPT_SET,
      canUpdate: Dn,
      initialTypeContainer: W,
      initialParentId: R,
      initialParentName: de,
      title: "Concept set",
      url: "conceptset",
      getBaseUrl: (f, Z) => {
        switch (f) {
          case j.WORKSPACE:
            return "/workspace/concept-sets/";
          case j.STUDY:
            return `/studies/${Z}/concept-sets/`;
          default:
            return "/concept-sets/";
        }
      },
      configMetadataValuesApi: {
        entityFilter: "subject",
        getListValues: wt,
        updateMetadataValue: rn,
        removeMetadataValue: er,
        createMetadataValue: nn,
        copyMetadataValue: Zn
      },
      callback: () => {
        Ke();
      }
    }
  ), Wn = /* @__PURE__ */ r.jsx(
    Jn,
    {
      id: v.id,
      name: v.name,
      aiMode: !0,
      metadataSubject: Nt.CONCEPT_SET,
      canUpdate: Dn,
      initialTypeContainer: W,
      initialParentId: R,
      initialParentName: de,
      title: "Concept set",
      url: "conceptset",
      getBaseUrl: (f, Z) => {
        switch (f) {
          case j.WORKSPACE:
            return "/workspace/concept-sets/";
          case j.STUDY:
            return `/studies/${Z}/concept-sets/`;
          default:
            return "/concept-sets/";
        }
      },
      configMetadataValuesApi: {
        entityFilter: "subject",
        getListValues: wt,
        updateMetadataValue: rn,
        removeMetadataValue: er,
        createMetadataValue: nn,
        copyMetadataValue: Zn
      },
      callback: () => {
        Ke();
      }
    },
    `${v.id}-aimetadata`
  ), Vn = /* @__PURE__ */ r.jsx(Be, { children: /* @__PURE__ */ r.jsx(
    N.vocabulary,
    {
      type: "component",
      name: "ai-suggested-concepts",
      path: ls,
      subModules: N,
      config: ds
    }
  ) }), Fn = /* @__PURE__ */ r.jsx(Be, { children: /* @__PURE__ */ r.jsx($t, { outlined: !0, children: /* @__PURE__ */ r.jsx(
    yi,
    {
      id: v.id,
      typeContainer: W,
      parentId: R
    }
  ) }) }), zn = /* @__PURE__ */ r.jsx(Be, { children: /* @__PURE__ */ r.jsx(
    N.vocabulary,
    {
      type: "component",
      name: "expression-concepts",
      path: as,
      subModules: N,
      config: {
        concepts: x == null ? void 0 : x.items,
        onChange: (f) => {
          Gt("items", f);
        },
        viewMode: Ue,
        parentId: R,
        typeContainer: W,
        mode: "stand-alone"
      }
    }
  ) });
  return /* @__PURE__ */ r.jsxs(_, { container: !0, px: 6, flexGrow: 1, flexDirection: "column", children: [
    /* @__PURE__ */ r.jsx(ho, { children: /* @__PURE__ */ r.jsx(
      Eo,
      {
        entity: Ee || W !== j.LIBRARY ? x : v,
        onDelete: us,
        disableSave: me !== P.SUCCESS || _e !== P.SUCCESS || es,
        saveInProgress: _e,
        onExport: rs,
        onSubmit: async (f) => {
          await fs(f);
        },
        onChange: W !== j.LIBRARY ? (f) => {
          Gt("name", f.name), Gt("description", f.description);
        } : void 0,
        onClickExtraActions: (f) => {
          ns(f);
        },
        onCompare: ms,
        onArchive: ps,
        onGenerate: Q && Xr && W != j.LIBRARY ? Cs : null,
        onPublish: ts,
        onCopy: async (f) => {
          const Z = await Kr(x);
          Z != null && Z.id && (l(`/${g}/${Z.id}`, { replace: !0 }), Ke());
        },
        versionPreview: Ee,
        onVersionRevert: Hr,
        onVersionSave: function() {
          pe({
            ...x,
            name: x.originName
          }), Zr(), Ke();
        },
        viewMode: Ue,
        libraryMode: ss,
        backToListPath: Mn ? "../../" : "",
        AdditionalActions: Mn && /* @__PURE__ */ r.jsx(
          N.library,
          {
            type: "component",
            name: "answer-publish-widget",
            subModules: N,
            config: {
              ...T,
              type: b.get("typePublish"),
              typeEntity: Nt.CONCEPT_SET,
              nameEntity: x == null ? void 0 : x.name,
              id: b.get("id"),
              isRedirect: !0,
              requestStatus: b.get("status")
            }
          }
        ),
        shareable: hs,
        onShare: Es,
        onSuggest: Q ? gs : void 0,
        suggestionStatus: c,
        nameError: m,
        saveOnlyActions: s
      }
    ) }),
    /* @__PURE__ */ r.jsxs(_, { item: !0, xs: 12, children: [
      /* @__PURE__ */ r.jsx(
        En,
        {
          tabs: os,
          withRouting: !0,
          secondary: !0
        }
      ),
      /* @__PURE__ */ r.jsx(fn, {})
    ] }),
    /* @__PURE__ */ r.jsx(_, { container: !0, item: !0, xs: 12, py: 3, children: s ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      Oe === "included" && Un,
      Oe === "source-codes" && kn,
      Oe === "versions" && $n,
      Oe === "meta-attributes" && Bn,
      Oe === "ai-meta-attributes" && Wn,
      Oe === "ai-suggested" && Vn,
      Oe === "usage" && Fn,
      Oe === "statistics" && /* @__PURE__ */ r.jsx(lr, {}),
      Oe === "expression" && zn
    ] }) : /* @__PURE__ */ r.jsxs(gr, { children: [
      /* @__PURE__ */ r.jsx(ye, { path: "included/*", element: Un }),
      /* @__PURE__ */ r.jsx(ye, { path: "source-codes/*", element: kn }),
      /* @__PURE__ */ r.jsx(ye, { path: "versions", element: $n }),
      /* @__PURE__ */ r.jsx(ye, { path: "meta-attributes", element: Bn }),
      /* @__PURE__ */ r.jsx(
        ye,
        {
          path: "ai-meta-attributes",
          element: Wn
        }
      ),
      /* @__PURE__ */ r.jsx(ye, { path: "ai-suggested", element: Vn }),
      /* @__PURE__ */ r.jsx(ye, { path: "usage", element: Fn }),
      /* @__PURE__ */ r.jsx(ye, { path: "*", element: zn }),
      /* @__PURE__ */ r.jsx(ye, { path: "statistics", element: /* @__PURE__ */ r.jsx(lr, {}) })
    ] }) })
  ] });
}, Ti = Le((e) => {
  const { name: t, config: n, ...s } = e, {
    onChange: a,
    values: o,
    conceptSets: i,
    defaultValue: l,
    conceptSet: p,
    onUpdate: c,
    onClear: d,
    concepts: m,
    onSave: E,
    onCancel: h,
    component: y,
    conceptSetId: D,
    fastMarker: L,
    viewMode: b,
    titleText: M,
    description: B,
    buttonText: g,
    returnEntityText: O,
    isSelect: T,
    entityType: N,
    initialData: K,
    initialDataByValue: z,
    simpleButtonMode: ne,
    localImport: G,
    embeddedReferenceOnly: S,
    isDark: $,
    typeContainer: Y,
    parentId: R,
    analysisMode: de,
    withAlias: W,
    disableActions: he = !1,
    exportConceptSet: ue,
    circleMode: C,
    hideSectionContent: w,
    conceptSetNameErrors: F,
    onConceptSetNameSubmit: Q,
    onConceptSetNameCancel: ce,
    refreshConceptSetReference: oe,
    renderSectionTitleAddon: u,
    onEditSection: v,
    onConceptSetEntityReady: X,
    onConceptSetEntitySaved: q,
    onAddConceptSet: ie,
    hideAddConceptSetAction: fe,
    hideCopySectionAction: A,
    hideEditSectionAction: I,
    saveOnlyActions: H
  } = n, pe = Y || j.WORKSPACE, Ee = rt(
    pe,
    R
  );
  return /* @__PURE__ */ r.jsxs(dn.Fragment, { children: [
    t === "widget-concept-set-import-button" && /* @__PURE__ */ r.jsx(
      Ca,
      {
        ...s,
        titleText: M,
        buttonText: g,
        returnEntityText: O,
        typeContainer: Y,
        parentId: R,
        isSelect: T,
        entityType: N,
        onChange: a,
        initialData: K,
        initialDataByValue: z,
        description: B,
        withAlias: W
      }
    ),
    t === "widget-concept-set-save" && /* @__PURE__ */ r.jsx(
      Ga,
      {
        ...s,
        concepts: m,
        onSave: E,
        onCancel: h,
        component: y,
        typeContainer: Y,
        parentId: R,
        disableActions: he
      }
    ),
    t === "widget-concept-set-choose-button" && /* @__PURE__ */ r.jsx(
      kr,
      {
        ...s,
        conceptSets: i,
        defaultValue: l,
        onUpdate: c,
        onClear: d,
        conceptSetId: D,
        typeContainer: Y,
        parentId: R,
        simpleButtonMode: ne,
        localImport: G,
        embeddedReferenceOnly: S
      }
    ),
    t === "view-concept-set-button" && /* @__PURE__ */ r.jsx(
      ri,
      {
        ...s,
        conceptSets: i,
        conceptSetId: D
      }
    ),
    t === "concept-set-form" && Ee && /* @__PURE__ */ r.jsx(
      Tn,
      {
        parentId: R,
        typeContainer: pe,
        createMethod: Ee,
        onCancel: () => h == null ? void 0 : h(),
        afterCreate: (me) => E == null ? void 0 : E(me)
      }
    ),
    t === "concept-set-sections-widget-new" && /* @__PURE__ */ r.jsx(
      ni,
      {
        ...s,
        conceptSets: i,
        onChange: a,
        viewMode: b,
        typeContainer: Y,
        parentId: R,
        analysisMode: de,
        exportConceptSet: ue,
        circleMode: C,
        hideSectionContent: w,
        conceptSetNameErrors: F,
        onConceptSetNameSubmit: Q,
        onConceptSetNameCancel: ce,
        refreshConceptSetReference: oe,
        renderSectionTitleAddon: u,
        onEditSection: v,
        onAddConceptSet: ie,
        hideAddConceptSetAction: fe,
        hideCopySectionAction: A,
        hideEditSectionAction: I
      }
    ),
    t === "concept-set-entity-embedded" && /* @__PURE__ */ r.jsx(
      Et.Provider,
      {
        value: {
          ...e,
          rootSettings: e.rootSettings || {
            rootPath: e.path || "workspace/concept-sets",
            rootTitle: e.title || "Concept sets"
          }
        },
        children: /* @__PURE__ */ r.jsx(
          Yr,
          {
            entityId: D,
            onEntityReady: X,
            onEntitySaved: q,
            saveOnlyActions: H
          }
        )
      }
    ),
    t === "home-widget-concept-set" && /* @__PURE__ */ r.jsx(ga, {})
  ] });
}), Di = (e) => {
  const { type: t } = e;
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    !t && /* @__PURE__ */ r.jsx(mi, { ...e }),
    t === "component" && /* @__PURE__ */ r.jsx(Ti, { ...e })
  ] });
};
export {
  Di as ConceptSet
};
//# sourceMappingURL=concept-sets.js.map
